// source: schemas/ccgames-boardgame.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

goog.exportSymbol('proto.ccgames.boardgame.Arbiter', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Arbiter.Action', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Arbiter.Action.ActionOneofCase', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Arbiter.Action.Analysis', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Arbiter.Action.Analysis.Flags', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Arbiter.Action.EndGame', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Arbiter.Action.Highlight', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Arbiter.Action.InitBoard', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Arbiter.Action.MarkTurn', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Arbiter.Action.Move', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Arbiter.Action.Move.Step', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Arbiter.Action.Move.Step.Add', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Arbiter.Action.Move.Step.Capture', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Arbiter.Action.Move.Step.Jumps', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Arbiter.Action.Move.Step.Replace', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.Branch', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Arbiter.Action.Move.Step.StepOfCase', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Arbiter.Action.RevokeHighlight', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Arbiter.Action.SetLen', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Arbiter.Action.SetSideToMove', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Arbiter.GameSave', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Arbiter.Piece', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Arbiter.Request', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Arbiter.Request.MakeMove', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Engine', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Engine.Request', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Engine.Request.ComputeBestMove', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Engine.Request.ComputeMoveGoal', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Engine.Request.GenerateReplay', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Engine.Request.Predication', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Engine.Response', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Engine.Response.ComputeBestMove', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Engine.Response.Prediction', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Game', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Game.PlayerColor', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Game.Result', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Game.ResultGenesis', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.Action', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.Action.ActionOneofCase', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.Action.ActivateGame', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.Action.CompleteGame', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.Action.SetAnonymousPlayer', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.Action.SetGameState', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.Action.ShowSummary', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.Action.ShowSummary.Item', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.ItemOneofCase', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.Action.ShowSummary.Kind', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.Actions', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.ClockExtension', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.ClockExtension.Action', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.ClockExtension.FreezeReason', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.DrawExtension', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.DrawExtension.Action', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.DrawExtension.Action.SetDrawState', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.DrawExtension.Request', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.DrawExtension.Request.AcceptDraw', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.DrawExtension.Request.ProposeDraw', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.DrawExtension.Request.RejectDraw', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.EloRankingExtension', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.EloRankingExtension.Action', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.EloRankingExtension.Action.SetPlayerElo', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.EloProgress', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.Error', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.Error.Code', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.FirebaseExtension', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.FirebaseExtension.Action', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.GameState', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.OnboardingExtension', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingProgress', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingResult', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.OpCodes', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.Request', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.Request.ConfirmReadiness', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.Request.MakeMove', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.Request.RequestOneofCase', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.SurrenderExtension', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.SurrenderExtension.Request', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.SurrenderExtension.Request.Surrender', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.TournamentExtension', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.TournamentExtension.Action', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetPlayerProgress', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetTournamentClock', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem', null, global);
goog.exportSymbol('proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Game = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Game, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Game.displayName = 'proto.ccgames.boardgame.Game';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Arbiter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Arbiter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Arbiter.displayName = 'proto.ccgames.boardgame.Arbiter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Arbiter.GameSave = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Arbiter.GameSave, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Arbiter.GameSave.displayName = 'proto.ccgames.boardgame.Arbiter.GameSave';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Arbiter.Piece = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Arbiter.Piece, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Arbiter.Piece.displayName = 'proto.ccgames.boardgame.Arbiter.Piece';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Arbiter.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Arbiter.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Arbiter.Request.displayName = 'proto.ccgames.boardgame.Arbiter.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Arbiter.Request.MakeMove = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Arbiter.Request.MakeMove, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Arbiter.Request.MakeMove.displayName = 'proto.ccgames.boardgame.Arbiter.Request.MakeMove';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Arbiter.Action = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.ccgames.boardgame.Arbiter.Action.oneofGroups_);
};
goog.inherits(proto.ccgames.boardgame.Arbiter.Action, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Arbiter.Action.displayName = 'proto.ccgames.boardgame.Arbiter.Action';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Arbiter.Action.InitBoard = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ccgames.boardgame.Arbiter.Action.InitBoard.repeatedFields_, null);
};
goog.inherits(proto.ccgames.boardgame.Arbiter.Action.InitBoard, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Arbiter.Action.InitBoard.displayName = 'proto.ccgames.boardgame.Arbiter.Action.InitBoard';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation.displayName = 'proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Arbiter.Action.Move = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ccgames.boardgame.Arbiter.Action.Move.repeatedFields_, null);
};
goog.inherits(proto.ccgames.boardgame.Arbiter.Action.Move, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Arbiter.Action.Move.displayName = 'proto.ccgames.boardgame.Arbiter.Action.Move';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.ccgames.boardgame.Arbiter.Action.Move.Step.oneofGroups_);
};
goog.inherits(proto.ccgames.boardgame.Arbiter.Action.Move.Step, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Arbiter.Action.Move.Step.displayName = 'proto.ccgames.boardgame.Arbiter.Action.Move.Step';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Jumps = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ccgames.boardgame.Arbiter.Action.Move.Step.Jumps.repeatedFields_, null);
};
goog.inherits(proto.ccgames.boardgame.Arbiter.Action.Move.Step.Jumps, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Arbiter.Action.Move.Step.Jumps.displayName = 'proto.ccgames.boardgame.Arbiter.Action.Move.Step.Jumps';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Capture = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Arbiter.Action.Move.Step.Capture, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Arbiter.Action.Move.Step.Capture.displayName = 'proto.ccgames.boardgame.Arbiter.Action.Move.Step.Capture';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Add = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Arbiter.Action.Move.Step.Add, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Arbiter.Action.Move.Step.Add.displayName = 'proto.ccgames.boardgame.Arbiter.Action.Move.Step.Add';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Replace = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Arbiter.Action.Move.Step.Replace, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Arbiter.Action.Move.Step.Replace.displayName = 'proto.ccgames.boardgame.Arbiter.Action.Move.Step.Replace';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.repeatedFields_, null);
};
goog.inherits(proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.displayName = 'proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.Branch = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.Branch, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.Branch.displayName = 'proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.Branch';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves.repeatedFields_, null);
};
goog.inherits(proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves.displayName = 'proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Arbiter.Action.SetSideToMove = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Arbiter.Action.SetSideToMove, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Arbiter.Action.SetSideToMove.displayName = 'proto.ccgames.boardgame.Arbiter.Action.SetSideToMove';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Arbiter.Action.EndGame = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Arbiter.Action.EndGame, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Arbiter.Action.EndGame.displayName = 'proto.ccgames.boardgame.Arbiter.Action.EndGame';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Arbiter.Action.MarkTurn = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ccgames.boardgame.Arbiter.Action.MarkTurn.repeatedFields_, null);
};
goog.inherits(proto.ccgames.boardgame.Arbiter.Action.MarkTurn, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Arbiter.Action.MarkTurn.displayName = 'proto.ccgames.boardgame.Arbiter.Action.MarkTurn';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Arbiter.Action.SetLen = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Arbiter.Action.SetLen, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Arbiter.Action.SetLen.displayName = 'proto.ccgames.boardgame.Arbiter.Action.SetLen';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Arbiter.Action.Highlight = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ccgames.boardgame.Arbiter.Action.Highlight.repeatedFields_, null);
};
goog.inherits(proto.ccgames.boardgame.Arbiter.Action.Highlight, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Arbiter.Action.Highlight.displayName = 'proto.ccgames.boardgame.Arbiter.Action.Highlight';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Arbiter.Action.RevokeHighlight = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Arbiter.Action.RevokeHighlight, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Arbiter.Action.RevokeHighlight.displayName = 'proto.ccgames.boardgame.Arbiter.Action.RevokeHighlight';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Arbiter.Action.Analysis = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Arbiter.Action.Analysis, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Arbiter.Action.Analysis.displayName = 'proto.ccgames.boardgame.Arbiter.Action.Analysis';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis.repeatedFields_, null);
};
goog.inherits(proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis.displayName = 'proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Engine = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Engine, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Engine.displayName = 'proto.ccgames.boardgame.Engine';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Engine.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Engine.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Engine.Request.displayName = 'proto.ccgames.boardgame.Engine.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Engine.Request.ComputeBestMove = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Engine.Request.ComputeBestMove, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Engine.Request.ComputeBestMove.displayName = 'proto.ccgames.boardgame.Engine.Request.ComputeBestMove';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Engine.Request.Predication = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Engine.Request.Predication, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Engine.Request.Predication.displayName = 'proto.ccgames.boardgame.Engine.Request.Predication';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Engine.Request.GenerateReplay = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Engine.Request.GenerateReplay, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Engine.Request.GenerateReplay.displayName = 'proto.ccgames.boardgame.Engine.Request.GenerateReplay';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Engine.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Engine.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Engine.Response.displayName = 'proto.ccgames.boardgame.Engine.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Engine.Response.ComputeBestMove = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Engine.Response.ComputeBestMove, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Engine.Response.ComputeBestMove.displayName = 'proto.ccgames.boardgame.Engine.Response.ComputeBestMove';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Engine.Response.Prediction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Engine.Response.Prediction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Engine.Response.Prediction.displayName = 'proto.ccgames.boardgame.Engine.Response.Prediction';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.displayName = 'proto.ccgames.boardgame.Rts';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.DrawExtension = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.DrawExtension, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.DrawExtension.displayName = 'proto.ccgames.boardgame.Rts.DrawExtension';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.DrawExtension.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.DrawExtension.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.DrawExtension.Request.displayName = 'proto.ccgames.boardgame.Rts.DrawExtension.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.DrawExtension.Request.ProposeDraw = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.DrawExtension.Request.ProposeDraw, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.DrawExtension.Request.ProposeDraw.displayName = 'proto.ccgames.boardgame.Rts.DrawExtension.Request.ProposeDraw';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.DrawExtension.Request.AcceptDraw = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.DrawExtension.Request.AcceptDraw, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.DrawExtension.Request.AcceptDraw.displayName = 'proto.ccgames.boardgame.Rts.DrawExtension.Request.AcceptDraw';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.DrawExtension.Request.RejectDraw = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.DrawExtension.Request.RejectDraw, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.DrawExtension.Request.RejectDraw.displayName = 'proto.ccgames.boardgame.Rts.DrawExtension.Request.RejectDraw';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.DrawExtension.Action = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.DrawExtension.Action, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.DrawExtension.Action.displayName = 'proto.ccgames.boardgame.Rts.DrawExtension.Action';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.DrawExtension.Action.SetDrawState = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.DrawExtension.Action.SetDrawState, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.DrawExtension.Action.SetDrawState.displayName = 'proto.ccgames.boardgame.Rts.DrawExtension.Action.SetDrawState';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.SurrenderExtension = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.SurrenderExtension, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.SurrenderExtension.displayName = 'proto.ccgames.boardgame.Rts.SurrenderExtension';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.SurrenderExtension.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.SurrenderExtension.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.SurrenderExtension.Request.displayName = 'proto.ccgames.boardgame.Rts.SurrenderExtension.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.SurrenderExtension.Request.Surrender = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.SurrenderExtension.Request.Surrender, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.SurrenderExtension.Request.Surrender.displayName = 'proto.ccgames.boardgame.Rts.SurrenderExtension.Request.Surrender';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.ClockExtension = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.ClockExtension, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.ClockExtension.displayName = 'proto.ccgames.boardgame.Rts.ClockExtension';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.ClockExtension.Action = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.ClockExtension.Action, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.ClockExtension.Action.displayName = 'proto.ccgames.boardgame.Rts.ClockExtension.Action';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState.displayName = 'proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.FirebaseExtension = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.FirebaseExtension, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.FirebaseExtension.displayName = 'proto.ccgames.boardgame.Rts.FirebaseExtension';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.FirebaseExtension.Action = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.FirebaseExtension.Action, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.FirebaseExtension.Action.displayName = 'proto.ccgames.boardgame.Rts.FirebaseExtension.Action';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer.displayName = 'proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.TournamentExtension = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.TournamentExtension, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.TournamentExtension.displayName = 'proto.ccgames.boardgame.Rts.TournamentExtension';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.displayName = 'proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress.displayName = 'proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.TournamentExtension.Action = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.TournamentExtension.Action, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.TournamentExtension.Action.displayName = 'proto.ccgames.boardgame.Rts.TournamentExtension.Action';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetPlayerProgress = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetPlayerProgress, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetPlayerProgress.displayName = 'proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetPlayerProgress';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetTournamentClock = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetTournamentClock, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetTournamentClock.displayName = 'proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetTournamentClock';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.EloRankingExtension = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.EloRankingExtension, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.EloRankingExtension.displayName = 'proto.ccgames.boardgame.Rts.EloRankingExtension';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.displayName = 'proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.EloProgress = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.EloProgress, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.EloProgress.displayName = 'proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.EloProgress';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.Action = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.EloRankingExtension.Action, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.EloRankingExtension.Action.displayName = 'proto.ccgames.boardgame.Rts.EloRankingExtension.Action';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.Action.SetPlayerElo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.EloRankingExtension.Action.SetPlayerElo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.EloRankingExtension.Action.SetPlayerElo.displayName = 'proto.ccgames.boardgame.Rts.EloRankingExtension.Action.SetPlayerElo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.OnboardingExtension = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.OnboardingExtension, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.OnboardingExtension.displayName = 'proto.ccgames.boardgame.Rts.OnboardingExtension';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.displayName = 'proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingProgress = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingProgress, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingProgress.displayName = 'proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingProgress';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingResult.displayName = 'proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.Error = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.Error, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.Error.displayName = 'proto.ccgames.boardgame.Rts.Error';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.ccgames.boardgame.Rts.Request.oneofGroups_);
};
goog.inherits(proto.ccgames.boardgame.Rts.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.Request.displayName = 'proto.ccgames.boardgame.Rts.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.Request.ConfirmReadiness = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.Request.ConfirmReadiness, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.Request.ConfirmReadiness.displayName = 'proto.ccgames.boardgame.Rts.Request.ConfirmReadiness';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.Request.MakeMove = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.Request.MakeMove, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.Request.MakeMove.displayName = 'proto.ccgames.boardgame.Rts.Request.MakeMove';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.Action = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.ccgames.boardgame.Rts.Action.oneofGroups_);
};
goog.inherits(proto.ccgames.boardgame.Rts.Action, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.Action.displayName = 'proto.ccgames.boardgame.Rts.Action';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.Action.SetGameState = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.Action.SetGameState, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.Action.SetGameState.displayName = 'proto.ccgames.boardgame.Rts.Action.SetGameState';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave.displayName = 'proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.Action.ActivateGame = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.Action.ActivateGame, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.Action.ActivateGame.displayName = 'proto.ccgames.boardgame.Rts.Action.ActivateGame';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.Action.CompleteGame = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.Action.CompleteGame, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.Action.CompleteGame.displayName = 'proto.ccgames.boardgame.Rts.Action.CompleteGame';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.Action.SetAnonymousPlayer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.Action.SetAnonymousPlayer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.Action.SetAnonymousPlayer.displayName = 'proto.ccgames.boardgame.Rts.Action.SetAnonymousPlayer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ccgames.boardgame.Rts.Action.ShowSummary.repeatedFields_, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.Action.ShowSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.Action.ShowSummary.displayName = 'proto.ccgames.boardgame.Rts.Action.ShowSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter.displayName = 'proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.Item = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.oneofGroups_);
};
goog.inherits(proto.ccgames.boardgame.Rts.Action.ShowSummary.Item, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.displayName = 'proto.ccgames.boardgame.Rts.Action.ShowSummary.Item';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ccgames.boardgame.Rts.Actions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ccgames.boardgame.Rts.Actions.repeatedFields_, null);
};
goog.inherits(proto.ccgames.boardgame.Rts.Actions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ccgames.boardgame.Rts.Actions.displayName = 'proto.ccgames.boardgame.Rts.Actions';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Game.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Game.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Game} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Game.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Game}
 */
proto.ccgames.boardgame.Game.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Game;
  return proto.ccgames.boardgame.Game.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Game} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Game}
 */
proto.ccgames.boardgame.Game.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Game.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Game.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Game} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Game.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.ccgames.boardgame.Game.Result = {
  WHITE_WIN: 0,
  BLACK_WIN: 1,
  DRAW: 2,
  NO_RESULT: 3
};

/**
 * @enum {number}
 */
proto.ccgames.boardgame.Game.ResultGenesis = {
  RESERVED: 0,
  CHECKMATE: 1,
  SURRENDER: 2,
  LOSS_ON_TIME: 3,
  NO_PAWNS_OR_MOVES: 4,
  RULES_VIOLATION: 50,
  OPPONENT_CONNECTIVITY_ERRORS: 49,
  ADJUDICATION: 51,
  STALEMATE: 101,
  INSUFFICIENT_MATERIAL: 102,
  FIFTY_MOVES_RULE: 103,
  TRIPLE_REPETITION: 104,
  DRAW_BY_AGREEMENT: 105,
  CONSECUTIVE_QUEEN_MOVES: 106,
  TECHNICAL_ISSUE: 201,
  TECHNICAL_MOVES_LIMIT_REACHED: 202,
  ABANDONED: 204
};

/**
 * @enum {number}
 */
proto.ccgames.boardgame.Game.PlayerColor = {
  UNDEFINED: 0,
  COLOR_WHITE: 2,
  COLOR_BLACK: 3
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Arbiter.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Arbiter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Arbiter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Arbiter}
 */
proto.ccgames.boardgame.Arbiter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Arbiter;
  return proto.ccgames.boardgame.Arbiter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Arbiter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Arbiter}
 */
proto.ccgames.boardgame.Arbiter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Arbiter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Arbiter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Arbiter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Arbiter.GameSave.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Arbiter.GameSave.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Arbiter.GameSave} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.GameSave.toObject = function(includeInstance, msg) {
  var f, obj = {
    fen: jspb.Message.getFieldWithDefault(msg, 1, ""),
    len: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Arbiter.GameSave}
 */
proto.ccgames.boardgame.Arbiter.GameSave.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Arbiter.GameSave;
  return proto.ccgames.boardgame.Arbiter.GameSave.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Arbiter.GameSave} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Arbiter.GameSave}
 */
proto.ccgames.boardgame.Arbiter.GameSave.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFen(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLen(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Arbiter.GameSave.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Arbiter.GameSave.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Arbiter.GameSave} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.GameSave.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFen();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLen();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string fen = 1;
 * @return {string}
 */
proto.ccgames.boardgame.Arbiter.GameSave.prototype.getFen = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ccgames.boardgame.Arbiter.GameSave} returns this
 */
proto.ccgames.boardgame.Arbiter.GameSave.prototype.setFen = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string len = 2;
 * @return {string}
 */
proto.ccgames.boardgame.Arbiter.GameSave.prototype.getLen = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ccgames.boardgame.Arbiter.GameSave} returns this
 */
proto.ccgames.boardgame.Arbiter.GameSave.prototype.setLen = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Arbiter.Piece.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Arbiter.Piece.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Arbiter.Piece} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Piece.toObject = function(includeInstance, msg) {
  var f, obj = {
    color: jspb.Message.getFieldWithDefault(msg, 1, 0),
    kind: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Arbiter.Piece}
 */
proto.ccgames.boardgame.Arbiter.Piece.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Arbiter.Piece;
  return proto.ccgames.boardgame.Arbiter.Piece.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Arbiter.Piece} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Arbiter.Piece}
 */
proto.ccgames.boardgame.Arbiter.Piece.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ccgames.boardgame.Game.PlayerColor} */ (reader.readEnum());
      msg.setColor(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setKind(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Arbiter.Piece.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Arbiter.Piece.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Arbiter.Piece} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Piece.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getColor();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getKind();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional Game.PlayerColor color = 1;
 * @return {!proto.ccgames.boardgame.Game.PlayerColor}
 */
proto.ccgames.boardgame.Arbiter.Piece.prototype.getColor = function() {
  return /** @type {!proto.ccgames.boardgame.Game.PlayerColor} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ccgames.boardgame.Game.PlayerColor} value
 * @return {!proto.ccgames.boardgame.Arbiter.Piece} returns this
 */
proto.ccgames.boardgame.Arbiter.Piece.prototype.setColor = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int32 kind = 2;
 * @return {number}
 */
proto.ccgames.boardgame.Arbiter.Piece.prototype.getKind = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ccgames.boardgame.Arbiter.Piece} returns this
 */
proto.ccgames.boardgame.Arbiter.Piece.prototype.setKind = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Arbiter.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Arbiter.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Arbiter.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Request.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Arbiter.Request}
 */
proto.ccgames.boardgame.Arbiter.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Arbiter.Request;
  return proto.ccgames.boardgame.Arbiter.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Arbiter.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Arbiter.Request}
 */
proto.ccgames.boardgame.Arbiter.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Arbiter.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Arbiter.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Arbiter.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Arbiter.Request.MakeMove.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Arbiter.Request.MakeMove.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Arbiter.Request.MakeMove} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Request.MakeMove.toObject = function(includeInstance, msg) {
  var f, obj = {
    gameSave: (f = msg.getGameSave()) && proto.ccgames.boardgame.Arbiter.GameSave.toObject(includeInstance, f),
    moveCode: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Arbiter.Request.MakeMove}
 */
proto.ccgames.boardgame.Arbiter.Request.MakeMove.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Arbiter.Request.MakeMove;
  return proto.ccgames.boardgame.Arbiter.Request.MakeMove.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Arbiter.Request.MakeMove} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Arbiter.Request.MakeMove}
 */
proto.ccgames.boardgame.Arbiter.Request.MakeMove.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ccgames.boardgame.Arbiter.GameSave;
      reader.readMessage(value,proto.ccgames.boardgame.Arbiter.GameSave.deserializeBinaryFromReader);
      msg.setGameSave(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMoveCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Arbiter.Request.MakeMove.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Arbiter.Request.MakeMove.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Arbiter.Request.MakeMove} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Request.MakeMove.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGameSave();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ccgames.boardgame.Arbiter.GameSave.serializeBinaryToWriter
    );
  }
  f = message.getMoveCode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional GameSave game_save = 1;
 * @return {?proto.ccgames.boardgame.Arbiter.GameSave}
 */
proto.ccgames.boardgame.Arbiter.Request.MakeMove.prototype.getGameSave = function() {
  return /** @type{?proto.ccgames.boardgame.Arbiter.GameSave} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Arbiter.GameSave, 1));
};


/**
 * @param {?proto.ccgames.boardgame.Arbiter.GameSave|undefined} value
 * @return {!proto.ccgames.boardgame.Arbiter.Request.MakeMove} returns this
*/
proto.ccgames.boardgame.Arbiter.Request.MakeMove.prototype.setGameSave = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Arbiter.Request.MakeMove} returns this
 */
proto.ccgames.boardgame.Arbiter.Request.MakeMove.prototype.clearGameSave = function() {
  return this.setGameSave(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Arbiter.Request.MakeMove.prototype.hasGameSave = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string move_code = 3;
 * @return {string}
 */
proto.ccgames.boardgame.Arbiter.Request.MakeMove.prototype.getMoveCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.ccgames.boardgame.Arbiter.Request.MakeMove} returns this
 */
proto.ccgames.boardgame.Arbiter.Request.MakeMove.prototype.setMoveCode = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.ccgames.boardgame.Arbiter.Action.oneofGroups_ = [[1,2,3,4,5,6,7,8,9,10]];

/**
 * @enum {number}
 */
proto.ccgames.boardgame.Arbiter.Action.ActionOneofCase = {
  ACTION_ONEOF_NOT_SET: 0,
  MOVE: 1,
  SET_AVAILABLE_MOVES: 2,
  SET_SIDE_TO_MOVE: 3,
  INIT_BOARD: 4,
  END_GAME: 5,
  SET_LEN: 6,
  HIGHLIGHT: 7,
  REVOKE_HIGHLIGHT: 8,
  MARK_END_TURN: 9,
  SHOW_MOVE_ANALYSIS: 10
};

/**
 * @return {proto.ccgames.boardgame.Arbiter.Action.ActionOneofCase}
 */
proto.ccgames.boardgame.Arbiter.Action.prototype.getActionOneofCase = function() {
  return /** @type {proto.ccgames.boardgame.Arbiter.Action.ActionOneofCase} */(jspb.Message.computeOneofCase(this, proto.ccgames.boardgame.Arbiter.Action.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Arbiter.Action.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Arbiter.Action.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Arbiter.Action} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.toObject = function(includeInstance, msg) {
  var f, obj = {
    move: (f = msg.getMove()) && proto.ccgames.boardgame.Arbiter.Action.Move.toObject(includeInstance, f),
    setAvailableMoves: (f = msg.getSetAvailableMoves()) && proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves.toObject(includeInstance, f),
    setSideToMove: (f = msg.getSetSideToMove()) && proto.ccgames.boardgame.Arbiter.Action.SetSideToMove.toObject(includeInstance, f),
    initBoard: (f = msg.getInitBoard()) && proto.ccgames.boardgame.Arbiter.Action.InitBoard.toObject(includeInstance, f),
    endGame: (f = msg.getEndGame()) && proto.ccgames.boardgame.Arbiter.Action.EndGame.toObject(includeInstance, f),
    setLen: (f = msg.getSetLen()) && proto.ccgames.boardgame.Arbiter.Action.SetLen.toObject(includeInstance, f),
    highlight: (f = msg.getHighlight()) && proto.ccgames.boardgame.Arbiter.Action.Highlight.toObject(includeInstance, f),
    revokeHighlight: (f = msg.getRevokeHighlight()) && proto.ccgames.boardgame.Arbiter.Action.RevokeHighlight.toObject(includeInstance, f),
    markEndTurn: (f = msg.getMarkEndTurn()) && proto.ccgames.boardgame.Arbiter.Action.MarkTurn.toObject(includeInstance, f),
    showMoveAnalysis: (f = msg.getShowMoveAnalysis()) && proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Arbiter.Action}
 */
proto.ccgames.boardgame.Arbiter.Action.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Arbiter.Action;
  return proto.ccgames.boardgame.Arbiter.Action.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Arbiter.Action} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Arbiter.Action}
 */
proto.ccgames.boardgame.Arbiter.Action.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ccgames.boardgame.Arbiter.Action.Move;
      reader.readMessage(value,proto.ccgames.boardgame.Arbiter.Action.Move.deserializeBinaryFromReader);
      msg.setMove(value);
      break;
    case 2:
      var value = new proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves;
      reader.readMessage(value,proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves.deserializeBinaryFromReader);
      msg.setSetAvailableMoves(value);
      break;
    case 3:
      var value = new proto.ccgames.boardgame.Arbiter.Action.SetSideToMove;
      reader.readMessage(value,proto.ccgames.boardgame.Arbiter.Action.SetSideToMove.deserializeBinaryFromReader);
      msg.setSetSideToMove(value);
      break;
    case 4:
      var value = new proto.ccgames.boardgame.Arbiter.Action.InitBoard;
      reader.readMessage(value,proto.ccgames.boardgame.Arbiter.Action.InitBoard.deserializeBinaryFromReader);
      msg.setInitBoard(value);
      break;
    case 5:
      var value = new proto.ccgames.boardgame.Arbiter.Action.EndGame;
      reader.readMessage(value,proto.ccgames.boardgame.Arbiter.Action.EndGame.deserializeBinaryFromReader);
      msg.setEndGame(value);
      break;
    case 6:
      var value = new proto.ccgames.boardgame.Arbiter.Action.SetLen;
      reader.readMessage(value,proto.ccgames.boardgame.Arbiter.Action.SetLen.deserializeBinaryFromReader);
      msg.setSetLen(value);
      break;
    case 7:
      var value = new proto.ccgames.boardgame.Arbiter.Action.Highlight;
      reader.readMessage(value,proto.ccgames.boardgame.Arbiter.Action.Highlight.deserializeBinaryFromReader);
      msg.setHighlight(value);
      break;
    case 8:
      var value = new proto.ccgames.boardgame.Arbiter.Action.RevokeHighlight;
      reader.readMessage(value,proto.ccgames.boardgame.Arbiter.Action.RevokeHighlight.deserializeBinaryFromReader);
      msg.setRevokeHighlight(value);
      break;
    case 9:
      var value = new proto.ccgames.boardgame.Arbiter.Action.MarkTurn;
      reader.readMessage(value,proto.ccgames.boardgame.Arbiter.Action.MarkTurn.deserializeBinaryFromReader);
      msg.setMarkEndTurn(value);
      break;
    case 10:
      var value = new proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis;
      reader.readMessage(value,proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis.deserializeBinaryFromReader);
      msg.setShowMoveAnalysis(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Arbiter.Action.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Arbiter.Action.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Arbiter.Action} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMove();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ccgames.boardgame.Arbiter.Action.Move.serializeBinaryToWriter
    );
  }
  f = message.getSetAvailableMoves();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves.serializeBinaryToWriter
    );
  }
  f = message.getSetSideToMove();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ccgames.boardgame.Arbiter.Action.SetSideToMove.serializeBinaryToWriter
    );
  }
  f = message.getInitBoard();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.ccgames.boardgame.Arbiter.Action.InitBoard.serializeBinaryToWriter
    );
  }
  f = message.getEndGame();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.ccgames.boardgame.Arbiter.Action.EndGame.serializeBinaryToWriter
    );
  }
  f = message.getSetLen();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.ccgames.boardgame.Arbiter.Action.SetLen.serializeBinaryToWriter
    );
  }
  f = message.getHighlight();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.ccgames.boardgame.Arbiter.Action.Highlight.serializeBinaryToWriter
    );
  }
  f = message.getRevokeHighlight();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.ccgames.boardgame.Arbiter.Action.RevokeHighlight.serializeBinaryToWriter
    );
  }
  f = message.getMarkEndTurn();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.ccgames.boardgame.Arbiter.Action.MarkTurn.serializeBinaryToWriter
    );
  }
  f = message.getShowMoveAnalysis();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis.serializeBinaryToWriter
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ccgames.boardgame.Arbiter.Action.InitBoard.repeatedFields_ = [5,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Arbiter.Action.InitBoard.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Arbiter.Action.InitBoard.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Arbiter.Action.InitBoard} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.InitBoard.toObject = function(includeInstance, msg) {
  var f, obj = {
    startingColor: jspb.Message.getFieldWithDefault(msg, 2, 0),
    boardId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    zeroFieldColor: jspb.Message.getFieldWithDefault(msg, 4, 0),
    piecesList: jspb.Message.toObjectList(msg.getPiecesList(),
    proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation.toObject, includeInstance),
    playableFieldIndexesList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.InitBoard}
 */
proto.ccgames.boardgame.Arbiter.Action.InitBoard.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Arbiter.Action.InitBoard;
  return proto.ccgames.boardgame.Arbiter.Action.InitBoard.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Arbiter.Action.InitBoard} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.InitBoard}
 */
proto.ccgames.boardgame.Arbiter.Action.InitBoard.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {!proto.ccgames.boardgame.Game.PlayerColor} */ (reader.readEnum());
      msg.setStartingColor(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBoardId(value);
      break;
    case 4:
      var value = /** @type {!proto.ccgames.boardgame.Game.PlayerColor} */ (reader.readEnum());
      msg.setZeroFieldColor(value);
      break;
    case 5:
      var value = new proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation;
      reader.readMessage(value,proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation.deserializeBinaryFromReader);
      msg.addPieces(value);
      break;
    case 6:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addPlayableFieldIndexes(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Arbiter.Action.InitBoard.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Arbiter.Action.InitBoard.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Arbiter.Action.InitBoard} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.InitBoard.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartingColor();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getBoardId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getZeroFieldColor();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getPiecesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation.serializeBinaryToWriter
    );
  }
  f = message.getPlayableFieldIndexesList();
  if (f.length > 0) {
    writer.writePackedInt32(
      6,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation.toObject = function(includeInstance, msg) {
  var f, obj = {
    piece: (f = msg.getPiece()) && proto.ccgames.boardgame.Arbiter.Piece.toObject(includeInstance, f),
    fieldIndex: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation}
 */
proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation;
  return proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation}
 */
proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ccgames.boardgame.Arbiter.Piece;
      reader.readMessage(value,proto.ccgames.boardgame.Arbiter.Piece.deserializeBinaryFromReader);
      msg.setPiece(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFieldIndex(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPiece();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ccgames.boardgame.Arbiter.Piece.serializeBinaryToWriter
    );
  }
  f = message.getFieldIndex();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional Piece piece = 1;
 * @return {?proto.ccgames.boardgame.Arbiter.Piece}
 */
proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation.prototype.getPiece = function() {
  return /** @type{?proto.ccgames.boardgame.Arbiter.Piece} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Arbiter.Piece, 1));
};


/**
 * @param {?proto.ccgames.boardgame.Arbiter.Piece|undefined} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation} returns this
*/
proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation.prototype.setPiece = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation.prototype.clearPiece = function() {
  return this.setPiece(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation.prototype.hasPiece = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 field_index = 2;
 * @return {number}
 */
proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation.prototype.getFieldIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation.prototype.setFieldIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional Game.PlayerColor starting_color = 2;
 * @return {!proto.ccgames.boardgame.Game.PlayerColor}
 */
proto.ccgames.boardgame.Arbiter.Action.InitBoard.prototype.getStartingColor = function() {
  return /** @type {!proto.ccgames.boardgame.Game.PlayerColor} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.ccgames.boardgame.Game.PlayerColor} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action.InitBoard} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.InitBoard.prototype.setStartingColor = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional int32 board_id = 3;
 * @return {number}
 */
proto.ccgames.boardgame.Arbiter.Action.InitBoard.prototype.getBoardId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action.InitBoard} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.InitBoard.prototype.setBoardId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional Game.PlayerColor zero_field_color = 4;
 * @return {!proto.ccgames.boardgame.Game.PlayerColor}
 */
proto.ccgames.boardgame.Arbiter.Action.InitBoard.prototype.getZeroFieldColor = function() {
  return /** @type {!proto.ccgames.boardgame.Game.PlayerColor} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.ccgames.boardgame.Game.PlayerColor} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action.InitBoard} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.InitBoard.prototype.setZeroFieldColor = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * repeated PieceLocation pieces = 5;
 * @return {!Array<!proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation>}
 */
proto.ccgames.boardgame.Arbiter.Action.InitBoard.prototype.getPiecesList = function() {
  return /** @type{!Array<!proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation, 5));
};


/**
 * @param {!Array<!proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation>} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action.InitBoard} returns this
*/
proto.ccgames.boardgame.Arbiter.Action.InitBoard.prototype.setPiecesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation}
 */
proto.ccgames.boardgame.Arbiter.Action.InitBoard.prototype.addPieces = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.ccgames.boardgame.Arbiter.Action.InitBoard.PieceLocation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.InitBoard} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.InitBoard.prototype.clearPiecesList = function() {
  return this.setPiecesList([]);
};


/**
 * repeated int32 playable_field_indexes = 6;
 * @return {!Array<number>}
 */
proto.ccgames.boardgame.Arbiter.Action.InitBoard.prototype.getPlayableFieldIndexesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action.InitBoard} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.InitBoard.prototype.setPlayableFieldIndexesList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.ccgames.boardgame.Arbiter.Action.InitBoard} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.InitBoard.prototype.addPlayableFieldIndexes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.InitBoard} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.InitBoard.prototype.clearPlayableFieldIndexesList = function() {
  return this.setPlayableFieldIndexesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ccgames.boardgame.Arbiter.Action.Move.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Arbiter.Action.Move.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Arbiter.Action.Move} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.Move.toObject = function(includeInstance, msg) {
  var f, obj = {
    stepsList: jspb.Message.toObjectList(msg.getStepsList(),
    proto.ccgames.boardgame.Arbiter.Action.Move.Step.toObject, includeInstance),
    code: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Arbiter.Action.Move;
  return proto.ccgames.boardgame.Arbiter.Action.Move.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Arbiter.Action.Move} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ccgames.boardgame.Arbiter.Action.Move.Step;
      reader.readMessage(value,proto.ccgames.boardgame.Arbiter.Action.Move.Step.deserializeBinaryFromReader);
      msg.addSteps(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Arbiter.Action.Move.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Arbiter.Action.Move} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.Move.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStepsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.ccgames.boardgame.Arbiter.Action.Move.Step.serializeBinaryToWriter
    );
  }
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.oneofGroups_ = [[1,2,3,4,5]];

/**
 * @enum {number}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.StepOfCase = {
  STEP_OF_NOT_SET: 0,
  JUMPS: 1,
  CAPTURE: 2,
  REPLACE: 3,
  ADD: 4,
  SPLIT: 5
};

/**
 * @return {proto.ccgames.boardgame.Arbiter.Action.Move.Step.StepOfCase}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.prototype.getStepOfCase = function() {
  return /** @type {proto.ccgames.boardgame.Arbiter.Action.Move.Step.StepOfCase} */(jspb.Message.computeOneofCase(this, proto.ccgames.boardgame.Arbiter.Action.Move.Step.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Arbiter.Action.Move.Step.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Arbiter.Action.Move.Step} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.toObject = function(includeInstance, msg) {
  var f, obj = {
    jumps: (f = msg.getJumps()) && proto.ccgames.boardgame.Arbiter.Action.Move.Step.Jumps.toObject(includeInstance, f),
    capture: (f = msg.getCapture()) && proto.ccgames.boardgame.Arbiter.Action.Move.Step.Capture.toObject(includeInstance, f),
    replace: (f = msg.getReplace()) && proto.ccgames.boardgame.Arbiter.Action.Move.Step.Replace.toObject(includeInstance, f),
    add: (f = msg.getAdd()) && proto.ccgames.boardgame.Arbiter.Action.Move.Step.Add.toObject(includeInstance, f),
    split: (f = msg.getSplit()) && proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Arbiter.Action.Move.Step;
  return proto.ccgames.boardgame.Arbiter.Action.Move.Step.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Arbiter.Action.Move.Step} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ccgames.boardgame.Arbiter.Action.Move.Step.Jumps;
      reader.readMessage(value,proto.ccgames.boardgame.Arbiter.Action.Move.Step.Jumps.deserializeBinaryFromReader);
      msg.setJumps(value);
      break;
    case 2:
      var value = new proto.ccgames.boardgame.Arbiter.Action.Move.Step.Capture;
      reader.readMessage(value,proto.ccgames.boardgame.Arbiter.Action.Move.Step.Capture.deserializeBinaryFromReader);
      msg.setCapture(value);
      break;
    case 3:
      var value = new proto.ccgames.boardgame.Arbiter.Action.Move.Step.Replace;
      reader.readMessage(value,proto.ccgames.boardgame.Arbiter.Action.Move.Step.Replace.deserializeBinaryFromReader);
      msg.setReplace(value);
      break;
    case 4:
      var value = new proto.ccgames.boardgame.Arbiter.Action.Move.Step.Add;
      reader.readMessage(value,proto.ccgames.boardgame.Arbiter.Action.Move.Step.Add.deserializeBinaryFromReader);
      msg.setAdd(value);
      break;
    case 5:
      var value = new proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split;
      reader.readMessage(value,proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.deserializeBinaryFromReader);
      msg.setSplit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Arbiter.Action.Move.Step.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Arbiter.Action.Move.Step} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJumps();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ccgames.boardgame.Arbiter.Action.Move.Step.Jumps.serializeBinaryToWriter
    );
  }
  f = message.getCapture();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ccgames.boardgame.Arbiter.Action.Move.Step.Capture.serializeBinaryToWriter
    );
  }
  f = message.getReplace();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ccgames.boardgame.Arbiter.Action.Move.Step.Replace.serializeBinaryToWriter
    );
  }
  f = message.getAdd();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.ccgames.boardgame.Arbiter.Action.Move.Step.Add.serializeBinaryToWriter
    );
  }
  f = message.getSplit();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.serializeBinaryToWriter
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Jumps.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Jumps.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Arbiter.Action.Move.Step.Jumps.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Jumps} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Jumps.toObject = function(includeInstance, msg) {
  var f, obj = {
    fieldIndexesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Jumps}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Jumps.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Arbiter.Action.Move.Step.Jumps;
  return proto.ccgames.boardgame.Arbiter.Action.Move.Step.Jumps.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Jumps} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Jumps}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Jumps.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addFieldIndexes(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Jumps.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Arbiter.Action.Move.Step.Jumps.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Jumps} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Jumps.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFieldIndexesList();
  if (f.length > 0) {
    writer.writePackedInt32(
      1,
      f
    );
  }
};


/**
 * repeated int32 field_indexes = 1;
 * @return {!Array<number>}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Jumps.prototype.getFieldIndexesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Jumps} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Jumps.prototype.setFieldIndexesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Jumps} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Jumps.prototype.addFieldIndexes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Jumps} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Jumps.prototype.clearFieldIndexesList = function() {
  return this.setFieldIndexesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Capture.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Arbiter.Action.Move.Step.Capture.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Capture} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Capture.toObject = function(includeInstance, msg) {
  var f, obj = {
    fieldIndex: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Capture}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Capture.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Arbiter.Action.Move.Step.Capture;
  return proto.ccgames.boardgame.Arbiter.Action.Move.Step.Capture.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Capture} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Capture}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Capture.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFieldIndex(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Capture.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Arbiter.Action.Move.Step.Capture.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Capture} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Capture.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFieldIndex();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 field_index = 1;
 * @return {number}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Capture.prototype.getFieldIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Capture} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Capture.prototype.setFieldIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Add.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Arbiter.Action.Move.Step.Add.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Add} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Add.toObject = function(includeInstance, msg) {
  var f, obj = {
    piece: (f = msg.getPiece()) && proto.ccgames.boardgame.Arbiter.Piece.toObject(includeInstance, f),
    fieldIndex: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Add}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Add.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Arbiter.Action.Move.Step.Add;
  return proto.ccgames.boardgame.Arbiter.Action.Move.Step.Add.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Add} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Add}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Add.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ccgames.boardgame.Arbiter.Piece;
      reader.readMessage(value,proto.ccgames.boardgame.Arbiter.Piece.deserializeBinaryFromReader);
      msg.setPiece(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFieldIndex(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Add.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Arbiter.Action.Move.Step.Add.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Add} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Add.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPiece();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ccgames.boardgame.Arbiter.Piece.serializeBinaryToWriter
    );
  }
  f = message.getFieldIndex();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional Piece piece = 1;
 * @return {?proto.ccgames.boardgame.Arbiter.Piece}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Add.prototype.getPiece = function() {
  return /** @type{?proto.ccgames.boardgame.Arbiter.Piece} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Arbiter.Piece, 1));
};


/**
 * @param {?proto.ccgames.boardgame.Arbiter.Piece|undefined} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Add} returns this
*/
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Add.prototype.setPiece = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Add} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Add.prototype.clearPiece = function() {
  return this.setPiece(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Add.prototype.hasPiece = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 field_index = 2;
 * @return {number}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Add.prototype.getFieldIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Add} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Add.prototype.setFieldIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Replace.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Arbiter.Action.Move.Step.Replace.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Replace} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Replace.toObject = function(includeInstance, msg) {
  var f, obj = {
    newPiece: (f = msg.getNewPiece()) && proto.ccgames.boardgame.Arbiter.Piece.toObject(includeInstance, f),
    fieldIndex: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Replace}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Replace.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Arbiter.Action.Move.Step.Replace;
  return proto.ccgames.boardgame.Arbiter.Action.Move.Step.Replace.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Replace} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Replace}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Replace.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ccgames.boardgame.Arbiter.Piece;
      reader.readMessage(value,proto.ccgames.boardgame.Arbiter.Piece.deserializeBinaryFromReader);
      msg.setNewPiece(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFieldIndex(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Replace.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Arbiter.Action.Move.Step.Replace.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Replace} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Replace.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNewPiece();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ccgames.boardgame.Arbiter.Piece.serializeBinaryToWriter
    );
  }
  f = message.getFieldIndex();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional Piece new_piece = 1;
 * @return {?proto.ccgames.boardgame.Arbiter.Piece}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Replace.prototype.getNewPiece = function() {
  return /** @type{?proto.ccgames.boardgame.Arbiter.Piece} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Arbiter.Piece, 1));
};


/**
 * @param {?proto.ccgames.boardgame.Arbiter.Piece|undefined} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Replace} returns this
*/
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Replace.prototype.setNewPiece = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Replace} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Replace.prototype.clearNewPiece = function() {
  return this.setNewPiece(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Replace.prototype.hasNewPiece = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 field_index = 2;
 * @return {number}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Replace.prototype.getFieldIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Replace} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Replace.prototype.setFieldIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.toObject = function(includeInstance, msg) {
  var f, obj = {
    branchesList: jspb.Message.toObjectList(msg.getBranchesList(),
    proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.Branch.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split;
  return proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.Branch;
      reader.readMessage(value,proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.Branch.deserializeBinaryFromReader);
      msg.addBranches(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBranchesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.Branch.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.Branch.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.Branch.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.Branch} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.Branch.toObject = function(includeInstance, msg) {
  var f, obj = {
    move: (f = msg.getMove()) && proto.ccgames.boardgame.Arbiter.Action.Move.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.Branch}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.Branch.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.Branch;
  return proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.Branch.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.Branch} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.Branch}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.Branch.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ccgames.boardgame.Arbiter.Action.Move;
      reader.readMessage(value,proto.ccgames.boardgame.Arbiter.Action.Move.deserializeBinaryFromReader);
      msg.setMove(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.Branch.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.Branch.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.Branch} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.Branch.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMove();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ccgames.boardgame.Arbiter.Action.Move.serializeBinaryToWriter
    );
  }
};


/**
 * optional Move move = 1;
 * @return {?proto.ccgames.boardgame.Arbiter.Action.Move}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.Branch.prototype.getMove = function() {
  return /** @type{?proto.ccgames.boardgame.Arbiter.Action.Move} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Arbiter.Action.Move, 1));
};


/**
 * @param {?proto.ccgames.boardgame.Arbiter.Action.Move|undefined} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.Branch} returns this
*/
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.Branch.prototype.setMove = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.Branch} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.Branch.prototype.clearMove = function() {
  return this.setMove(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.Branch.prototype.hasMove = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated Branch branches = 1;
 * @return {!Array<!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.Branch>}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.prototype.getBranchesList = function() {
  return /** @type{!Array<!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.Branch>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.Branch, 1));
};


/**
 * @param {!Array<!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.Branch>} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split} returns this
*/
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.prototype.setBranchesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.Branch=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.Branch}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.prototype.addBranches = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.Branch, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split.prototype.clearBranchesList = function() {
  return this.setBranchesList([]);
};


/**
 * optional Jumps jumps = 1;
 * @return {?proto.ccgames.boardgame.Arbiter.Action.Move.Step.Jumps}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.prototype.getJumps = function() {
  return /** @type{?proto.ccgames.boardgame.Arbiter.Action.Move.Step.Jumps} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Arbiter.Action.Move.Step.Jumps, 1));
};


/**
 * @param {?proto.ccgames.boardgame.Arbiter.Action.Move.Step.Jumps|undefined} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step} returns this
*/
proto.ccgames.boardgame.Arbiter.Action.Move.Step.prototype.setJumps = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.ccgames.boardgame.Arbiter.Action.Move.Step.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.prototype.clearJumps = function() {
  return this.setJumps(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.prototype.hasJumps = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Capture capture = 2;
 * @return {?proto.ccgames.boardgame.Arbiter.Action.Move.Step.Capture}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.prototype.getCapture = function() {
  return /** @type{?proto.ccgames.boardgame.Arbiter.Action.Move.Step.Capture} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Arbiter.Action.Move.Step.Capture, 2));
};


/**
 * @param {?proto.ccgames.boardgame.Arbiter.Action.Move.Step.Capture|undefined} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step} returns this
*/
proto.ccgames.boardgame.Arbiter.Action.Move.Step.prototype.setCapture = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.ccgames.boardgame.Arbiter.Action.Move.Step.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.prototype.clearCapture = function() {
  return this.setCapture(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.prototype.hasCapture = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Replace replace = 3;
 * @return {?proto.ccgames.boardgame.Arbiter.Action.Move.Step.Replace}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.prototype.getReplace = function() {
  return /** @type{?proto.ccgames.boardgame.Arbiter.Action.Move.Step.Replace} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Arbiter.Action.Move.Step.Replace, 3));
};


/**
 * @param {?proto.ccgames.boardgame.Arbiter.Action.Move.Step.Replace|undefined} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step} returns this
*/
proto.ccgames.boardgame.Arbiter.Action.Move.Step.prototype.setReplace = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.ccgames.boardgame.Arbiter.Action.Move.Step.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.prototype.clearReplace = function() {
  return this.setReplace(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.prototype.hasReplace = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Add add = 4;
 * @return {?proto.ccgames.boardgame.Arbiter.Action.Move.Step.Add}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.prototype.getAdd = function() {
  return /** @type{?proto.ccgames.boardgame.Arbiter.Action.Move.Step.Add} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Arbiter.Action.Move.Step.Add, 4));
};


/**
 * @param {?proto.ccgames.boardgame.Arbiter.Action.Move.Step.Add|undefined} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step} returns this
*/
proto.ccgames.boardgame.Arbiter.Action.Move.Step.prototype.setAdd = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.ccgames.boardgame.Arbiter.Action.Move.Step.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.prototype.clearAdd = function() {
  return this.setAdd(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.prototype.hasAdd = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Split split = 5;
 * @return {?proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.prototype.getSplit = function() {
  return /** @type{?proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split, 5));
};


/**
 * @param {?proto.ccgames.boardgame.Arbiter.Action.Move.Step.Split|undefined} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step} returns this
*/
proto.ccgames.boardgame.Arbiter.Action.Move.Step.prototype.setSplit = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.ccgames.boardgame.Arbiter.Action.Move.Step.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.prototype.clearSplit = function() {
  return this.setSplit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.Step.prototype.hasSplit = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * repeated Step steps = 1;
 * @return {!Array<!proto.ccgames.boardgame.Arbiter.Action.Move.Step>}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.prototype.getStepsList = function() {
  return /** @type{!Array<!proto.ccgames.boardgame.Arbiter.Action.Move.Step>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ccgames.boardgame.Arbiter.Action.Move.Step, 1));
};


/**
 * @param {!Array<!proto.ccgames.boardgame.Arbiter.Action.Move.Step>} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move} returns this
*/
proto.ccgames.boardgame.Arbiter.Action.Move.prototype.setStepsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.ccgames.boardgame.Arbiter.Action.Move.Step=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move.Step}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.prototype.addSteps = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.ccgames.boardgame.Arbiter.Action.Move.Step, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.Move.prototype.clearStepsList = function() {
  return this.setStepsList([]);
};


/**
 * optional string code = 2;
 * @return {string}
 */
proto.ccgames.boardgame.Arbiter.Action.Move.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.Move.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves.toObject = function(includeInstance, msg) {
  var f, obj = {
    availableMovesList: jspb.Message.toObjectList(msg.getAvailableMovesList(),
    proto.ccgames.boardgame.Arbiter.Action.Move.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves}
 */
proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves;
  return proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves}
 */
proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ccgames.boardgame.Arbiter.Action.Move;
      reader.readMessage(value,proto.ccgames.boardgame.Arbiter.Action.Move.deserializeBinaryFromReader);
      msg.addAvailableMoves(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAvailableMovesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.ccgames.boardgame.Arbiter.Action.Move.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Move available_moves = 1;
 * @return {!Array<!proto.ccgames.boardgame.Arbiter.Action.Move>}
 */
proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves.prototype.getAvailableMovesList = function() {
  return /** @type{!Array<!proto.ccgames.boardgame.Arbiter.Action.Move>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ccgames.boardgame.Arbiter.Action.Move, 1));
};


/**
 * @param {!Array<!proto.ccgames.boardgame.Arbiter.Action.Move>} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves} returns this
*/
proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves.prototype.setAvailableMovesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.ccgames.boardgame.Arbiter.Action.Move=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Move}
 */
proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves.prototype.addAvailableMoves = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.ccgames.boardgame.Arbiter.Action.Move, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves.prototype.clearAvailableMovesList = function() {
  return this.setAvailableMovesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Arbiter.Action.SetSideToMove.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Arbiter.Action.SetSideToMove.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Arbiter.Action.SetSideToMove} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.SetSideToMove.toObject = function(includeInstance, msg) {
  var f, obj = {
    sideToMove: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.SetSideToMove}
 */
proto.ccgames.boardgame.Arbiter.Action.SetSideToMove.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Arbiter.Action.SetSideToMove;
  return proto.ccgames.boardgame.Arbiter.Action.SetSideToMove.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Arbiter.Action.SetSideToMove} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.SetSideToMove}
 */
proto.ccgames.boardgame.Arbiter.Action.SetSideToMove.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ccgames.boardgame.Game.PlayerColor} */ (reader.readEnum());
      msg.setSideToMove(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Arbiter.Action.SetSideToMove.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Arbiter.Action.SetSideToMove.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Arbiter.Action.SetSideToMove} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.SetSideToMove.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSideToMove();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional Game.PlayerColor side_to_move = 1;
 * @return {!proto.ccgames.boardgame.Game.PlayerColor}
 */
proto.ccgames.boardgame.Arbiter.Action.SetSideToMove.prototype.getSideToMove = function() {
  return /** @type {!proto.ccgames.boardgame.Game.PlayerColor} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ccgames.boardgame.Game.PlayerColor} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action.SetSideToMove} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.SetSideToMove.prototype.setSideToMove = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Arbiter.Action.EndGame.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Arbiter.Action.EndGame.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Arbiter.Action.EndGame} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.EndGame.toObject = function(includeInstance, msg) {
  var f, obj = {
    result: jspb.Message.getFieldWithDefault(msg, 1, 0),
    resultGenesis: jspb.Message.getFieldWithDefault(msg, 2, 0),
    gameSave: (f = msg.getGameSave()) && proto.ccgames.boardgame.Arbiter.GameSave.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.EndGame}
 */
proto.ccgames.boardgame.Arbiter.Action.EndGame.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Arbiter.Action.EndGame;
  return proto.ccgames.boardgame.Arbiter.Action.EndGame.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Arbiter.Action.EndGame} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.EndGame}
 */
proto.ccgames.boardgame.Arbiter.Action.EndGame.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ccgames.boardgame.Game.Result} */ (reader.readEnum());
      msg.setResult(value);
      break;
    case 2:
      var value = /** @type {!proto.ccgames.boardgame.Game.ResultGenesis} */ (reader.readEnum());
      msg.setResultGenesis(value);
      break;
    case 3:
      var value = new proto.ccgames.boardgame.Arbiter.GameSave;
      reader.readMessage(value,proto.ccgames.boardgame.Arbiter.GameSave.deserializeBinaryFromReader);
      msg.setGameSave(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Arbiter.Action.EndGame.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Arbiter.Action.EndGame.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Arbiter.Action.EndGame} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.EndGame.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResult();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getResultGenesis();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getGameSave();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ccgames.boardgame.Arbiter.GameSave.serializeBinaryToWriter
    );
  }
};


/**
 * optional Game.Result result = 1;
 * @return {!proto.ccgames.boardgame.Game.Result}
 */
proto.ccgames.boardgame.Arbiter.Action.EndGame.prototype.getResult = function() {
  return /** @type {!proto.ccgames.boardgame.Game.Result} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ccgames.boardgame.Game.Result} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action.EndGame} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.EndGame.prototype.setResult = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional Game.ResultGenesis result_genesis = 2;
 * @return {!proto.ccgames.boardgame.Game.ResultGenesis}
 */
proto.ccgames.boardgame.Arbiter.Action.EndGame.prototype.getResultGenesis = function() {
  return /** @type {!proto.ccgames.boardgame.Game.ResultGenesis} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.ccgames.boardgame.Game.ResultGenesis} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action.EndGame} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.EndGame.prototype.setResultGenesis = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional GameSave game_save = 3;
 * @return {?proto.ccgames.boardgame.Arbiter.GameSave}
 */
proto.ccgames.boardgame.Arbiter.Action.EndGame.prototype.getGameSave = function() {
  return /** @type{?proto.ccgames.boardgame.Arbiter.GameSave} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Arbiter.GameSave, 3));
};


/**
 * @param {?proto.ccgames.boardgame.Arbiter.GameSave|undefined} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action.EndGame} returns this
*/
proto.ccgames.boardgame.Arbiter.Action.EndGame.prototype.setGameSave = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.EndGame} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.EndGame.prototype.clearGameSave = function() {
  return this.setGameSave(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Arbiter.Action.EndGame.prototype.hasGameSave = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ccgames.boardgame.Arbiter.Action.MarkTurn.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Arbiter.Action.MarkTurn.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Arbiter.Action.MarkTurn.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Arbiter.Action.MarkTurn} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.MarkTurn.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    undoActionsList: jspb.Message.toObjectList(msg.getUndoActionsList(),
    proto.ccgames.boardgame.Arbiter.Action.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.MarkTurn}
 */
proto.ccgames.boardgame.Arbiter.Action.MarkTurn.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Arbiter.Action.MarkTurn;
  return proto.ccgames.boardgame.Arbiter.Action.MarkTurn.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Arbiter.Action.MarkTurn} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.MarkTurn}
 */
proto.ccgames.boardgame.Arbiter.Action.MarkTurn.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.ccgames.boardgame.Arbiter.Action;
      reader.readMessage(value,proto.ccgames.boardgame.Arbiter.Action.deserializeBinaryFromReader);
      msg.addUndoActions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Arbiter.Action.MarkTurn.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Arbiter.Action.MarkTurn.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Arbiter.Action.MarkTurn} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.MarkTurn.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getUndoActionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.ccgames.boardgame.Arbiter.Action.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 id = 1;
 * @return {number}
 */
proto.ccgames.boardgame.Arbiter.Action.MarkTurn.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action.MarkTurn} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.MarkTurn.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated Action undo_actions = 2;
 * @return {!Array<!proto.ccgames.boardgame.Arbiter.Action>}
 */
proto.ccgames.boardgame.Arbiter.Action.MarkTurn.prototype.getUndoActionsList = function() {
  return /** @type{!Array<!proto.ccgames.boardgame.Arbiter.Action>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ccgames.boardgame.Arbiter.Action, 2));
};


/**
 * @param {!Array<!proto.ccgames.boardgame.Arbiter.Action>} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action.MarkTurn} returns this
*/
proto.ccgames.boardgame.Arbiter.Action.MarkTurn.prototype.setUndoActionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.ccgames.boardgame.Arbiter.Action=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ccgames.boardgame.Arbiter.Action}
 */
proto.ccgames.boardgame.Arbiter.Action.MarkTurn.prototype.addUndoActions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.ccgames.boardgame.Arbiter.Action, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.MarkTurn} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.MarkTurn.prototype.clearUndoActionsList = function() {
  return this.setUndoActionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Arbiter.Action.SetLen.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Arbiter.Action.SetLen.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Arbiter.Action.SetLen} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.SetLen.toObject = function(includeInstance, msg) {
  var f, obj = {
    len: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.SetLen}
 */
proto.ccgames.boardgame.Arbiter.Action.SetLen.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Arbiter.Action.SetLen;
  return proto.ccgames.boardgame.Arbiter.Action.SetLen.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Arbiter.Action.SetLen} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.SetLen}
 */
proto.ccgames.boardgame.Arbiter.Action.SetLen.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLen(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Arbiter.Action.SetLen.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Arbiter.Action.SetLen.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Arbiter.Action.SetLen} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.SetLen.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLen();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string len = 1;
 * @return {string}
 */
proto.ccgames.boardgame.Arbiter.Action.SetLen.prototype.getLen = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action.SetLen} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.SetLen.prototype.setLen = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ccgames.boardgame.Arbiter.Action.Highlight.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Arbiter.Action.Highlight.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Arbiter.Action.Highlight.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Arbiter.Action.Highlight} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.Highlight.toObject = function(includeInstance, msg) {
  var f, obj = {
    kind: jspb.Message.getFieldWithDefault(msg, 1, 0),
    fieldIndexesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    importance: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Highlight}
 */
proto.ccgames.boardgame.Arbiter.Action.Highlight.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Arbiter.Action.Highlight;
  return proto.ccgames.boardgame.Arbiter.Action.Highlight.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Arbiter.Action.Highlight} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Highlight}
 */
proto.ccgames.boardgame.Arbiter.Action.Highlight.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setKind(value);
      break;
    case 2:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addFieldIndexes(values[i]);
      }
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setImportance(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Arbiter.Action.Highlight.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Arbiter.Action.Highlight.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Arbiter.Action.Highlight} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.Highlight.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKind();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getFieldIndexesList();
  if (f.length > 0) {
    writer.writePackedInt32(
      2,
      f
    );
  }
  f = message.getImportance();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int32 kind = 1;
 * @return {number}
 */
proto.ccgames.boardgame.Arbiter.Action.Highlight.prototype.getKind = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Highlight} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.Highlight.prototype.setKind = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated int32 field_indexes = 2;
 * @return {!Array<number>}
 */
proto.ccgames.boardgame.Arbiter.Action.Highlight.prototype.getFieldIndexesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Highlight} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.Highlight.prototype.setFieldIndexesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Highlight} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.Highlight.prototype.addFieldIndexes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Highlight} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.Highlight.prototype.clearFieldIndexesList = function() {
  return this.setFieldIndexesList([]);
};


/**
 * optional int32 importance = 3;
 * @return {number}
 */
proto.ccgames.boardgame.Arbiter.Action.Highlight.prototype.getImportance = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Highlight} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.Highlight.prototype.setImportance = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Arbiter.Action.RevokeHighlight.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Arbiter.Action.RevokeHighlight.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Arbiter.Action.RevokeHighlight} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.RevokeHighlight.toObject = function(includeInstance, msg) {
  var f, obj = {
    kind: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.RevokeHighlight}
 */
proto.ccgames.boardgame.Arbiter.Action.RevokeHighlight.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Arbiter.Action.RevokeHighlight;
  return proto.ccgames.boardgame.Arbiter.Action.RevokeHighlight.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Arbiter.Action.RevokeHighlight} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.RevokeHighlight}
 */
proto.ccgames.boardgame.Arbiter.Action.RevokeHighlight.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setKind(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Arbiter.Action.RevokeHighlight.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Arbiter.Action.RevokeHighlight.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Arbiter.Action.RevokeHighlight} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.RevokeHighlight.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKind();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 kind = 1;
 * @return {number}
 */
proto.ccgames.boardgame.Arbiter.Action.RevokeHighlight.prototype.getKind = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action.RevokeHighlight} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.RevokeHighlight.prototype.setKind = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Arbiter.Action.Analysis.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Arbiter.Action.Analysis.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Arbiter.Action.Analysis} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.Analysis.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Analysis}
 */
proto.ccgames.boardgame.Arbiter.Action.Analysis.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Arbiter.Action.Analysis;
  return proto.ccgames.boardgame.Arbiter.Action.Analysis.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Arbiter.Action.Analysis} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Analysis}
 */
proto.ccgames.boardgame.Arbiter.Action.Analysis.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Arbiter.Action.Analysis.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Arbiter.Action.Analysis.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Arbiter.Action.Analysis} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.Analysis.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.ccgames.boardgame.Arbiter.Action.Analysis.Flags = {
  UNDEFINED: 0,
  WIN_PREDICTION: 1,
  LOSS_PREDICTION: 2,
  GREAT_MOVE: 3,
  GOOD_MOVE: 4,
  SUBOPTIMAL_MOVE: 5,
  WRONG_MOVE: 6,
  DISASTROUS_MOVE: 7
};


/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis.toObject = function(includeInstance, msg) {
  var f, obj = {
    score: jspb.Message.getFieldWithDefault(msg, 1, 0),
    beforeMoveScore: jspb.Message.getFieldWithDefault(msg, 2, 0),
    flagsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    movesToEnd: jspb.Message.getFieldWithDefault(msg, 4, 0),
    optimalMove: (f = msg.getOptimalMove()) && proto.ccgames.boardgame.Arbiter.Action.Move.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis}
 */
proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis;
  return proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis}
 */
proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setScore(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBeforeMoveScore(value);
      break;
    case 3:
      var values = /** @type {!Array<!proto.ccgames.boardgame.Arbiter.Action.Analysis.Flags>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addFlags(values[i]);
      }
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setMovesToEnd(value);
      break;
    case 5:
      var value = new proto.ccgames.boardgame.Arbiter.Action.Move;
      reader.readMessage(value,proto.ccgames.boardgame.Arbiter.Action.Move.deserializeBinaryFromReader);
      msg.setOptimalMove(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScore();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getBeforeMoveScore();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getFlagsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getOptimalMove();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.ccgames.boardgame.Arbiter.Action.Move.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 score = 1;
 * @return {number}
 */
proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis.prototype.getScore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis.prototype.setScore = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 before_move_score = 2;
 * @return {number}
 */
proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis.prototype.getBeforeMoveScore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis.prototype.setBeforeMoveScore = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated Flags flags = 3;
 * @return {!Array<!proto.ccgames.boardgame.Arbiter.Action.Analysis.Flags>}
 */
proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis.prototype.getFlagsList = function() {
  return /** @type {!Array<!proto.ccgames.boardgame.Arbiter.Action.Analysis.Flags>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<!proto.ccgames.boardgame.Arbiter.Action.Analysis.Flags>} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis.prototype.setFlagsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {!proto.ccgames.boardgame.Arbiter.Action.Analysis.Flags} value
 * @param {number=} opt_index
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis.prototype.addFlags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis.prototype.clearFlagsList = function() {
  return this.setFlagsList([]);
};


/**
 * optional uint32 moves_to_end = 4;
 * @return {number}
 */
proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis.prototype.getMovesToEnd = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis.prototype.setMovesToEnd = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis.prototype.clearMovesToEnd = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis.prototype.hasMovesToEnd = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Move optimal_move = 5;
 * @return {?proto.ccgames.boardgame.Arbiter.Action.Move}
 */
proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis.prototype.getOptimalMove = function() {
  return /** @type{?proto.ccgames.boardgame.Arbiter.Action.Move} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Arbiter.Action.Move, 5));
};


/**
 * @param {?proto.ccgames.boardgame.Arbiter.Action.Move|undefined} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis} returns this
*/
proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis.prototype.setOptimalMove = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis.prototype.clearOptimalMove = function() {
  return this.setOptimalMove(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis.prototype.hasOptimalMove = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Move move = 1;
 * @return {?proto.ccgames.boardgame.Arbiter.Action.Move}
 */
proto.ccgames.boardgame.Arbiter.Action.prototype.getMove = function() {
  return /** @type{?proto.ccgames.boardgame.Arbiter.Action.Move} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Arbiter.Action.Move, 1));
};


/**
 * @param {?proto.ccgames.boardgame.Arbiter.Action.Move|undefined} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action} returns this
*/
proto.ccgames.boardgame.Arbiter.Action.prototype.setMove = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.ccgames.boardgame.Arbiter.Action.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Arbiter.Action} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.prototype.clearMove = function() {
  return this.setMove(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Arbiter.Action.prototype.hasMove = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SetAvailableMoves set_available_moves = 2;
 * @return {?proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves}
 */
proto.ccgames.boardgame.Arbiter.Action.prototype.getSetAvailableMoves = function() {
  return /** @type{?proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves, 2));
};


/**
 * @param {?proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves|undefined} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action} returns this
*/
proto.ccgames.boardgame.Arbiter.Action.prototype.setSetAvailableMoves = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.ccgames.boardgame.Arbiter.Action.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Arbiter.Action} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.prototype.clearSetAvailableMoves = function() {
  return this.setSetAvailableMoves(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Arbiter.Action.prototype.hasSetAvailableMoves = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional SetSideToMove set_side_to_move = 3;
 * @return {?proto.ccgames.boardgame.Arbiter.Action.SetSideToMove}
 */
proto.ccgames.boardgame.Arbiter.Action.prototype.getSetSideToMove = function() {
  return /** @type{?proto.ccgames.boardgame.Arbiter.Action.SetSideToMove} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Arbiter.Action.SetSideToMove, 3));
};


/**
 * @param {?proto.ccgames.boardgame.Arbiter.Action.SetSideToMove|undefined} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action} returns this
*/
proto.ccgames.boardgame.Arbiter.Action.prototype.setSetSideToMove = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.ccgames.boardgame.Arbiter.Action.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Arbiter.Action} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.prototype.clearSetSideToMove = function() {
  return this.setSetSideToMove(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Arbiter.Action.prototype.hasSetSideToMove = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional InitBoard init_board = 4;
 * @return {?proto.ccgames.boardgame.Arbiter.Action.InitBoard}
 */
proto.ccgames.boardgame.Arbiter.Action.prototype.getInitBoard = function() {
  return /** @type{?proto.ccgames.boardgame.Arbiter.Action.InitBoard} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Arbiter.Action.InitBoard, 4));
};


/**
 * @param {?proto.ccgames.boardgame.Arbiter.Action.InitBoard|undefined} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action} returns this
*/
proto.ccgames.boardgame.Arbiter.Action.prototype.setInitBoard = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.ccgames.boardgame.Arbiter.Action.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Arbiter.Action} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.prototype.clearInitBoard = function() {
  return this.setInitBoard(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Arbiter.Action.prototype.hasInitBoard = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional EndGame end_game = 5;
 * @return {?proto.ccgames.boardgame.Arbiter.Action.EndGame}
 */
proto.ccgames.boardgame.Arbiter.Action.prototype.getEndGame = function() {
  return /** @type{?proto.ccgames.boardgame.Arbiter.Action.EndGame} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Arbiter.Action.EndGame, 5));
};


/**
 * @param {?proto.ccgames.boardgame.Arbiter.Action.EndGame|undefined} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action} returns this
*/
proto.ccgames.boardgame.Arbiter.Action.prototype.setEndGame = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.ccgames.boardgame.Arbiter.Action.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Arbiter.Action} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.prototype.clearEndGame = function() {
  return this.setEndGame(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Arbiter.Action.prototype.hasEndGame = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional SetLen set_len = 6;
 * @return {?proto.ccgames.boardgame.Arbiter.Action.SetLen}
 */
proto.ccgames.boardgame.Arbiter.Action.prototype.getSetLen = function() {
  return /** @type{?proto.ccgames.boardgame.Arbiter.Action.SetLen} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Arbiter.Action.SetLen, 6));
};


/**
 * @param {?proto.ccgames.boardgame.Arbiter.Action.SetLen|undefined} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action} returns this
*/
proto.ccgames.boardgame.Arbiter.Action.prototype.setSetLen = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.ccgames.boardgame.Arbiter.Action.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Arbiter.Action} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.prototype.clearSetLen = function() {
  return this.setSetLen(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Arbiter.Action.prototype.hasSetLen = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Highlight highlight = 7;
 * @return {?proto.ccgames.boardgame.Arbiter.Action.Highlight}
 */
proto.ccgames.boardgame.Arbiter.Action.prototype.getHighlight = function() {
  return /** @type{?proto.ccgames.boardgame.Arbiter.Action.Highlight} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Arbiter.Action.Highlight, 7));
};


/**
 * @param {?proto.ccgames.boardgame.Arbiter.Action.Highlight|undefined} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action} returns this
*/
proto.ccgames.boardgame.Arbiter.Action.prototype.setHighlight = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.ccgames.boardgame.Arbiter.Action.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Arbiter.Action} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.prototype.clearHighlight = function() {
  return this.setHighlight(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Arbiter.Action.prototype.hasHighlight = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional RevokeHighlight revoke_highlight = 8;
 * @return {?proto.ccgames.boardgame.Arbiter.Action.RevokeHighlight}
 */
proto.ccgames.boardgame.Arbiter.Action.prototype.getRevokeHighlight = function() {
  return /** @type{?proto.ccgames.boardgame.Arbiter.Action.RevokeHighlight} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Arbiter.Action.RevokeHighlight, 8));
};


/**
 * @param {?proto.ccgames.boardgame.Arbiter.Action.RevokeHighlight|undefined} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action} returns this
*/
proto.ccgames.boardgame.Arbiter.Action.prototype.setRevokeHighlight = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.ccgames.boardgame.Arbiter.Action.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Arbiter.Action} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.prototype.clearRevokeHighlight = function() {
  return this.setRevokeHighlight(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Arbiter.Action.prototype.hasRevokeHighlight = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional MarkTurn mark_end_turn = 9;
 * @return {?proto.ccgames.boardgame.Arbiter.Action.MarkTurn}
 */
proto.ccgames.boardgame.Arbiter.Action.prototype.getMarkEndTurn = function() {
  return /** @type{?proto.ccgames.boardgame.Arbiter.Action.MarkTurn} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Arbiter.Action.MarkTurn, 9));
};


/**
 * @param {?proto.ccgames.boardgame.Arbiter.Action.MarkTurn|undefined} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action} returns this
*/
proto.ccgames.boardgame.Arbiter.Action.prototype.setMarkEndTurn = function(value) {
  return jspb.Message.setOneofWrapperField(this, 9, proto.ccgames.boardgame.Arbiter.Action.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Arbiter.Action} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.prototype.clearMarkEndTurn = function() {
  return this.setMarkEndTurn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Arbiter.Action.prototype.hasMarkEndTurn = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional Analysis.ShowMoveAnalysis show_move_analysis = 10;
 * @return {?proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis}
 */
proto.ccgames.boardgame.Arbiter.Action.prototype.getShowMoveAnalysis = function() {
  return /** @type{?proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis, 10));
};


/**
 * @param {?proto.ccgames.boardgame.Arbiter.Action.Analysis.ShowMoveAnalysis|undefined} value
 * @return {!proto.ccgames.boardgame.Arbiter.Action} returns this
*/
proto.ccgames.boardgame.Arbiter.Action.prototype.setShowMoveAnalysis = function(value) {
  return jspb.Message.setOneofWrapperField(this, 10, proto.ccgames.boardgame.Arbiter.Action.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Arbiter.Action} returns this
 */
proto.ccgames.boardgame.Arbiter.Action.prototype.clearShowMoveAnalysis = function() {
  return this.setShowMoveAnalysis(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Arbiter.Action.prototype.hasShowMoveAnalysis = function() {
  return jspb.Message.getField(this, 10) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Engine.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Engine.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Engine} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Engine.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Engine}
 */
proto.ccgames.boardgame.Engine.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Engine;
  return proto.ccgames.boardgame.Engine.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Engine} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Engine}
 */
proto.ccgames.boardgame.Engine.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Engine.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Engine.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Engine} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Engine.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Engine.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Engine.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Engine.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Engine.Request.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Engine.Request}
 */
proto.ccgames.boardgame.Engine.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Engine.Request;
  return proto.ccgames.boardgame.Engine.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Engine.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Engine.Request}
 */
proto.ccgames.boardgame.Engine.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Engine.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Engine.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Engine.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Engine.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.ccgames.boardgame.Engine.Request.ComputeMoveGoal = {
  WIN: 0,
  LOSE: 1
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Engine.Request.ComputeBestMove.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Engine.Request.ComputeBestMove.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Engine.Request.ComputeBestMove} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Engine.Request.ComputeBestMove.toObject = function(includeInstance, msg) {
  var f, obj = {
    save: (f = msg.getSave()) && proto.ccgames.boardgame.Arbiter.GameSave.toObject(includeInstance, f),
    goal: jspb.Message.getFieldWithDefault(msg, 3, 0),
    difficultyLevel: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Engine.Request.ComputeBestMove}
 */
proto.ccgames.boardgame.Engine.Request.ComputeBestMove.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Engine.Request.ComputeBestMove;
  return proto.ccgames.boardgame.Engine.Request.ComputeBestMove.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Engine.Request.ComputeBestMove} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Engine.Request.ComputeBestMove}
 */
proto.ccgames.boardgame.Engine.Request.ComputeBestMove.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ccgames.boardgame.Arbiter.GameSave;
      reader.readMessage(value,proto.ccgames.boardgame.Arbiter.GameSave.deserializeBinaryFromReader);
      msg.setSave(value);
      break;
    case 3:
      var value = /** @type {!proto.ccgames.boardgame.Engine.Request.ComputeMoveGoal} */ (reader.readEnum());
      msg.setGoal(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDifficultyLevel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Engine.Request.ComputeBestMove.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Engine.Request.ComputeBestMove.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Engine.Request.ComputeBestMove} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Engine.Request.ComputeBestMove.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSave();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ccgames.boardgame.Arbiter.GameSave.serializeBinaryToWriter
    );
  }
  f = message.getGoal();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getDifficultyLevel();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
};


/**
 * optional Arbiter.GameSave save = 1;
 * @return {?proto.ccgames.boardgame.Arbiter.GameSave}
 */
proto.ccgames.boardgame.Engine.Request.ComputeBestMove.prototype.getSave = function() {
  return /** @type{?proto.ccgames.boardgame.Arbiter.GameSave} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Arbiter.GameSave, 1));
};


/**
 * @param {?proto.ccgames.boardgame.Arbiter.GameSave|undefined} value
 * @return {!proto.ccgames.boardgame.Engine.Request.ComputeBestMove} returns this
*/
proto.ccgames.boardgame.Engine.Request.ComputeBestMove.prototype.setSave = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Engine.Request.ComputeBestMove} returns this
 */
proto.ccgames.boardgame.Engine.Request.ComputeBestMove.prototype.clearSave = function() {
  return this.setSave(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Engine.Request.ComputeBestMove.prototype.hasSave = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ComputeMoveGoal goal = 3;
 * @return {!proto.ccgames.boardgame.Engine.Request.ComputeMoveGoal}
 */
proto.ccgames.boardgame.Engine.Request.ComputeBestMove.prototype.getGoal = function() {
  return /** @type {!proto.ccgames.boardgame.Engine.Request.ComputeMoveGoal} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.ccgames.boardgame.Engine.Request.ComputeMoveGoal} value
 * @return {!proto.ccgames.boardgame.Engine.Request.ComputeBestMove} returns this
 */
proto.ccgames.boardgame.Engine.Request.ComputeBestMove.prototype.setGoal = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional uint32 difficulty_level = 2;
 * @return {number}
 */
proto.ccgames.boardgame.Engine.Request.ComputeBestMove.prototype.getDifficultyLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ccgames.boardgame.Engine.Request.ComputeBestMove} returns this
 */
proto.ccgames.boardgame.Engine.Request.ComputeBestMove.prototype.setDifficultyLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Engine.Request.Predication.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Engine.Request.Predication.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Engine.Request.Predication} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Engine.Request.Predication.toObject = function(includeInstance, msg) {
  var f, obj = {
    save: (f = msg.getSave()) && proto.ccgames.boardgame.Arbiter.GameSave.toObject(includeInstance, f),
    player: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Engine.Request.Predication}
 */
proto.ccgames.boardgame.Engine.Request.Predication.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Engine.Request.Predication;
  return proto.ccgames.boardgame.Engine.Request.Predication.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Engine.Request.Predication} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Engine.Request.Predication}
 */
proto.ccgames.boardgame.Engine.Request.Predication.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ccgames.boardgame.Arbiter.GameSave;
      reader.readMessage(value,proto.ccgames.boardgame.Arbiter.GameSave.deserializeBinaryFromReader);
      msg.setSave(value);
      break;
    case 2:
      var value = /** @type {!proto.ccgames.boardgame.Game.PlayerColor} */ (reader.readEnum());
      msg.setPlayer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Engine.Request.Predication.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Engine.Request.Predication.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Engine.Request.Predication} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Engine.Request.Predication.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSave();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ccgames.boardgame.Arbiter.GameSave.serializeBinaryToWriter
    );
  }
  f = message.getPlayer();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional Arbiter.GameSave save = 1;
 * @return {?proto.ccgames.boardgame.Arbiter.GameSave}
 */
proto.ccgames.boardgame.Engine.Request.Predication.prototype.getSave = function() {
  return /** @type{?proto.ccgames.boardgame.Arbiter.GameSave} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Arbiter.GameSave, 1));
};


/**
 * @param {?proto.ccgames.boardgame.Arbiter.GameSave|undefined} value
 * @return {!proto.ccgames.boardgame.Engine.Request.Predication} returns this
*/
proto.ccgames.boardgame.Engine.Request.Predication.prototype.setSave = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Engine.Request.Predication} returns this
 */
proto.ccgames.boardgame.Engine.Request.Predication.prototype.clearSave = function() {
  return this.setSave(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Engine.Request.Predication.prototype.hasSave = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Game.PlayerColor player = 2;
 * @return {!proto.ccgames.boardgame.Game.PlayerColor}
 */
proto.ccgames.boardgame.Engine.Request.Predication.prototype.getPlayer = function() {
  return /** @type {!proto.ccgames.boardgame.Game.PlayerColor} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.ccgames.boardgame.Game.PlayerColor} value
 * @return {!proto.ccgames.boardgame.Engine.Request.Predication} returns this
 */
proto.ccgames.boardgame.Engine.Request.Predication.prototype.setPlayer = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Engine.Request.GenerateReplay.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Engine.Request.GenerateReplay.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Engine.Request.GenerateReplay} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Engine.Request.GenerateReplay.toObject = function(includeInstance, msg) {
  var f, obj = {
    save: (f = msg.getSave()) && proto.ccgames.boardgame.Arbiter.GameSave.toObject(includeInstance, f),
    includeAnalysis: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Engine.Request.GenerateReplay}
 */
proto.ccgames.boardgame.Engine.Request.GenerateReplay.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Engine.Request.GenerateReplay;
  return proto.ccgames.boardgame.Engine.Request.GenerateReplay.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Engine.Request.GenerateReplay} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Engine.Request.GenerateReplay}
 */
proto.ccgames.boardgame.Engine.Request.GenerateReplay.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ccgames.boardgame.Arbiter.GameSave;
      reader.readMessage(value,proto.ccgames.boardgame.Arbiter.GameSave.deserializeBinaryFromReader);
      msg.setSave(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeAnalysis(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Engine.Request.GenerateReplay.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Engine.Request.GenerateReplay.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Engine.Request.GenerateReplay} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Engine.Request.GenerateReplay.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSave();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ccgames.boardgame.Arbiter.GameSave.serializeBinaryToWriter
    );
  }
  f = message.getIncludeAnalysis();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional Arbiter.GameSave save = 1;
 * @return {?proto.ccgames.boardgame.Arbiter.GameSave}
 */
proto.ccgames.boardgame.Engine.Request.GenerateReplay.prototype.getSave = function() {
  return /** @type{?proto.ccgames.boardgame.Arbiter.GameSave} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Arbiter.GameSave, 1));
};


/**
 * @param {?proto.ccgames.boardgame.Arbiter.GameSave|undefined} value
 * @return {!proto.ccgames.boardgame.Engine.Request.GenerateReplay} returns this
*/
proto.ccgames.boardgame.Engine.Request.GenerateReplay.prototype.setSave = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Engine.Request.GenerateReplay} returns this
 */
proto.ccgames.boardgame.Engine.Request.GenerateReplay.prototype.clearSave = function() {
  return this.setSave(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Engine.Request.GenerateReplay.prototype.hasSave = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool include_analysis = 2;
 * @return {boolean}
 */
proto.ccgames.boardgame.Engine.Request.GenerateReplay.prototype.getIncludeAnalysis = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ccgames.boardgame.Engine.Request.GenerateReplay} returns this
 */
proto.ccgames.boardgame.Engine.Request.GenerateReplay.prototype.setIncludeAnalysis = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Engine.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Engine.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Engine.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Engine.Response.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Engine.Response}
 */
proto.ccgames.boardgame.Engine.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Engine.Response;
  return proto.ccgames.boardgame.Engine.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Engine.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Engine.Response}
 */
proto.ccgames.boardgame.Engine.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Engine.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Engine.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Engine.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Engine.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Engine.Response.ComputeBestMove.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Engine.Response.ComputeBestMove.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Engine.Response.ComputeBestMove} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Engine.Response.ComputeBestMove.toObject = function(includeInstance, msg) {
  var f, obj = {
    moveCode: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Engine.Response.ComputeBestMove}
 */
proto.ccgames.boardgame.Engine.Response.ComputeBestMove.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Engine.Response.ComputeBestMove;
  return proto.ccgames.boardgame.Engine.Response.ComputeBestMove.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Engine.Response.ComputeBestMove} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Engine.Response.ComputeBestMove}
 */
proto.ccgames.boardgame.Engine.Response.ComputeBestMove.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMoveCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Engine.Response.ComputeBestMove.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Engine.Response.ComputeBestMove.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Engine.Response.ComputeBestMove} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Engine.Response.ComputeBestMove.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMoveCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string move_code = 1;
 * @return {string}
 */
proto.ccgames.boardgame.Engine.Response.ComputeBestMove.prototype.getMoveCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ccgames.boardgame.Engine.Response.ComputeBestMove} returns this
 */
proto.ccgames.boardgame.Engine.Response.ComputeBestMove.prototype.setMoveCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Engine.Response.Prediction.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Engine.Response.Prediction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Engine.Response.Prediction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Engine.Response.Prediction.toObject = function(includeInstance, msg) {
  var f, obj = {
    result: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Engine.Response.Prediction}
 */
proto.ccgames.boardgame.Engine.Response.Prediction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Engine.Response.Prediction;
  return proto.ccgames.boardgame.Engine.Response.Prediction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Engine.Response.Prediction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Engine.Response.Prediction}
 */
proto.ccgames.boardgame.Engine.Response.Prediction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setResult(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Engine.Response.Prediction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Engine.Response.Prediction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Engine.Response.Prediction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Engine.Response.Prediction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResult();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool result = 1;
 * @return {boolean}
 */
proto.ccgames.boardgame.Engine.Response.Prediction.prototype.getResult = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ccgames.boardgame.Engine.Response.Prediction} returns this
 */
proto.ccgames.boardgame.Engine.Response.Prediction.prototype.setResult = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts}
 */
proto.ccgames.boardgame.Rts.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts;
  return proto.ccgames.boardgame.Rts.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts}
 */
proto.ccgames.boardgame.Rts.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.ccgames.boardgame.Rts.OpCodes = {
  OPCODE_ACTIONS: 0,
  OPCODE_REQUESTS: 1,
  OPCODE_ERRORS: 2
};

/**
 * @enum {number}
 */
proto.ccgames.boardgame.Rts.GameState = {
  UNDEFINED: 0,
  STATE_AWAITING_PLAYERS: 1,
  STATE_ACTIVE: 2,
  STATE_COMPLETE: 3
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.DrawExtension.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.DrawExtension.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.DrawExtension} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.DrawExtension.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.DrawExtension}
 */
proto.ccgames.boardgame.Rts.DrawExtension.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.DrawExtension;
  return proto.ccgames.boardgame.Rts.DrawExtension.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.DrawExtension} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.DrawExtension}
 */
proto.ccgames.boardgame.Rts.DrawExtension.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.DrawExtension.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.DrawExtension.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.DrawExtension} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.DrawExtension.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.DrawExtension.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.DrawExtension.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.DrawExtension.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.DrawExtension.Request.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.DrawExtension.Request}
 */
proto.ccgames.boardgame.Rts.DrawExtension.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.DrawExtension.Request;
  return proto.ccgames.boardgame.Rts.DrawExtension.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.DrawExtension.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.DrawExtension.Request}
 */
proto.ccgames.boardgame.Rts.DrawExtension.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.DrawExtension.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.DrawExtension.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.DrawExtension.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.DrawExtension.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.DrawExtension.Request.ProposeDraw.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.DrawExtension.Request.ProposeDraw.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.DrawExtension.Request.ProposeDraw} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.DrawExtension.Request.ProposeDraw.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.DrawExtension.Request.ProposeDraw}
 */
proto.ccgames.boardgame.Rts.DrawExtension.Request.ProposeDraw.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.DrawExtension.Request.ProposeDraw;
  return proto.ccgames.boardgame.Rts.DrawExtension.Request.ProposeDraw.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.DrawExtension.Request.ProposeDraw} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.DrawExtension.Request.ProposeDraw}
 */
proto.ccgames.boardgame.Rts.DrawExtension.Request.ProposeDraw.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.DrawExtension.Request.ProposeDraw.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.DrawExtension.Request.ProposeDraw.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.DrawExtension.Request.ProposeDraw} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.DrawExtension.Request.ProposeDraw.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.DrawExtension.Request.AcceptDraw.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.DrawExtension.Request.AcceptDraw.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.DrawExtension.Request.AcceptDraw} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.DrawExtension.Request.AcceptDraw.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.DrawExtension.Request.AcceptDraw}
 */
proto.ccgames.boardgame.Rts.DrawExtension.Request.AcceptDraw.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.DrawExtension.Request.AcceptDraw;
  return proto.ccgames.boardgame.Rts.DrawExtension.Request.AcceptDraw.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.DrawExtension.Request.AcceptDraw} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.DrawExtension.Request.AcceptDraw}
 */
proto.ccgames.boardgame.Rts.DrawExtension.Request.AcceptDraw.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.DrawExtension.Request.AcceptDraw.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.DrawExtension.Request.AcceptDraw.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.DrawExtension.Request.AcceptDraw} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.DrawExtension.Request.AcceptDraw.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.DrawExtension.Request.RejectDraw.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.DrawExtension.Request.RejectDraw.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.DrawExtension.Request.RejectDraw} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.DrawExtension.Request.RejectDraw.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.DrawExtension.Request.RejectDraw}
 */
proto.ccgames.boardgame.Rts.DrawExtension.Request.RejectDraw.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.DrawExtension.Request.RejectDraw;
  return proto.ccgames.boardgame.Rts.DrawExtension.Request.RejectDraw.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.DrawExtension.Request.RejectDraw} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.DrawExtension.Request.RejectDraw}
 */
proto.ccgames.boardgame.Rts.DrawExtension.Request.RejectDraw.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.DrawExtension.Request.RejectDraw.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.DrawExtension.Request.RejectDraw.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.DrawExtension.Request.RejectDraw} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.DrawExtension.Request.RejectDraw.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.DrawExtension.Action.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.DrawExtension.Action.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.DrawExtension.Action} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.DrawExtension.Action.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.DrawExtension.Action}
 */
proto.ccgames.boardgame.Rts.DrawExtension.Action.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.DrawExtension.Action;
  return proto.ccgames.boardgame.Rts.DrawExtension.Action.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.DrawExtension.Action} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.DrawExtension.Action}
 */
proto.ccgames.boardgame.Rts.DrawExtension.Action.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.DrawExtension.Action.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.DrawExtension.Action.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.DrawExtension.Action} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.DrawExtension.Action.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.DrawExtension.Action.SetDrawState.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.DrawExtension.Action.SetDrawState.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.DrawExtension.Action.SetDrawState} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.DrawExtension.Action.SetDrawState.toObject = function(includeInstance, msg) {
  var f, obj = {
    canProposeDraw: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    canAcceptOrRejectDraw: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    shouldInformAboutProposalRejection: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.DrawExtension.Action.SetDrawState}
 */
proto.ccgames.boardgame.Rts.DrawExtension.Action.SetDrawState.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.DrawExtension.Action.SetDrawState;
  return proto.ccgames.boardgame.Rts.DrawExtension.Action.SetDrawState.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.DrawExtension.Action.SetDrawState} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.DrawExtension.Action.SetDrawState}
 */
proto.ccgames.boardgame.Rts.DrawExtension.Action.SetDrawState.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCanProposeDraw(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCanAcceptOrRejectDraw(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShouldInformAboutProposalRejection(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.DrawExtension.Action.SetDrawState.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.DrawExtension.Action.SetDrawState.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.DrawExtension.Action.SetDrawState} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.DrawExtension.Action.SetDrawState.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCanProposeDraw();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getCanAcceptOrRejectDraw();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getShouldInformAboutProposalRejection();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional bool can_propose_draw = 2;
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.DrawExtension.Action.SetDrawState.prototype.getCanProposeDraw = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ccgames.boardgame.Rts.DrawExtension.Action.SetDrawState} returns this
 */
proto.ccgames.boardgame.Rts.DrawExtension.Action.SetDrawState.prototype.setCanProposeDraw = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool can_accept_or_reject_draw = 3;
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.DrawExtension.Action.SetDrawState.prototype.getCanAcceptOrRejectDraw = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ccgames.boardgame.Rts.DrawExtension.Action.SetDrawState} returns this
 */
proto.ccgames.boardgame.Rts.DrawExtension.Action.SetDrawState.prototype.setCanAcceptOrRejectDraw = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool should_inform_about_proposal_rejection = 4;
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.DrawExtension.Action.SetDrawState.prototype.getShouldInformAboutProposalRejection = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ccgames.boardgame.Rts.DrawExtension.Action.SetDrawState} returns this
 */
proto.ccgames.boardgame.Rts.DrawExtension.Action.SetDrawState.prototype.setShouldInformAboutProposalRejection = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.SurrenderExtension.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.SurrenderExtension.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.SurrenderExtension} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.SurrenderExtension.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.SurrenderExtension}
 */
proto.ccgames.boardgame.Rts.SurrenderExtension.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.SurrenderExtension;
  return proto.ccgames.boardgame.Rts.SurrenderExtension.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.SurrenderExtension} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.SurrenderExtension}
 */
proto.ccgames.boardgame.Rts.SurrenderExtension.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.SurrenderExtension.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.SurrenderExtension.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.SurrenderExtension} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.SurrenderExtension.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.SurrenderExtension.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.SurrenderExtension.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.SurrenderExtension.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.SurrenderExtension.Request.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.SurrenderExtension.Request}
 */
proto.ccgames.boardgame.Rts.SurrenderExtension.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.SurrenderExtension.Request;
  return proto.ccgames.boardgame.Rts.SurrenderExtension.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.SurrenderExtension.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.SurrenderExtension.Request}
 */
proto.ccgames.boardgame.Rts.SurrenderExtension.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.SurrenderExtension.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.SurrenderExtension.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.SurrenderExtension.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.SurrenderExtension.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.SurrenderExtension.Request.Surrender.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.SurrenderExtension.Request.Surrender.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.SurrenderExtension.Request.Surrender} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.SurrenderExtension.Request.Surrender.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.SurrenderExtension.Request.Surrender}
 */
proto.ccgames.boardgame.Rts.SurrenderExtension.Request.Surrender.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.SurrenderExtension.Request.Surrender;
  return proto.ccgames.boardgame.Rts.SurrenderExtension.Request.Surrender.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.SurrenderExtension.Request.Surrender} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.SurrenderExtension.Request.Surrender}
 */
proto.ccgames.boardgame.Rts.SurrenderExtension.Request.Surrender.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.SurrenderExtension.Request.Surrender.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.SurrenderExtension.Request.Surrender.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.SurrenderExtension.Request.Surrender} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.SurrenderExtension.Request.Surrender.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.ClockExtension.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.ClockExtension.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.ClockExtension} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.ClockExtension.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.ClockExtension}
 */
proto.ccgames.boardgame.Rts.ClockExtension.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.ClockExtension;
  return proto.ccgames.boardgame.Rts.ClockExtension.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.ClockExtension} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.ClockExtension}
 */
proto.ccgames.boardgame.Rts.ClockExtension.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.ClockExtension.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.ClockExtension.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.ClockExtension} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.ClockExtension.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.ccgames.boardgame.Rts.ClockExtension.FreezeReason = {
  UNDEFINED: 0,
  DISCONNECTED: 1,
  OPPONENT_TURN: 2,
  GAME_NOT_STARTED: 3
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.ClockExtension.Action.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.ClockExtension.Action.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.ClockExtension.Action} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.ClockExtension.Action.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.ClockExtension.Action}
 */
proto.ccgames.boardgame.Rts.ClockExtension.Action.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.ClockExtension.Action;
  return proto.ccgames.boardgame.Rts.ClockExtension.Action.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.ClockExtension.Action} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.ClockExtension.Action}
 */
proto.ccgames.boardgame.Rts.ClockExtension.Action.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.ClockExtension.Action.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.ClockExtension.Action.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.ClockExtension.Action} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.ClockExtension.Action.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState.toObject = function(includeInstance, msg) {
  var f, obj = {
    playerColor: jspb.Message.getFieldWithDefault(msg, 1, 0),
    leftMilliseconds: jspb.Message.getFieldWithDefault(msg, 2, 0),
    visible: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    freeze: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    freezeReason: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState}
 */
proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState;
  return proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState}
 */
proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ccgames.boardgame.Game.PlayerColor} */ (reader.readEnum());
      msg.setPlayerColor(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLeftMilliseconds(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVisible(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFreeze(value);
      break;
    case 5:
      var value = /** @type {!proto.ccgames.boardgame.Rts.ClockExtension.FreezeReason} */ (reader.readEnum());
      msg.setFreezeReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlayerColor();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getLeftMilliseconds();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getVisible();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getFreeze();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getFreezeReason();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * optional Game.PlayerColor player_color = 1;
 * @return {!proto.ccgames.boardgame.Game.PlayerColor}
 */
proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState.prototype.getPlayerColor = function() {
  return /** @type {!proto.ccgames.boardgame.Game.PlayerColor} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ccgames.boardgame.Game.PlayerColor} value
 * @return {!proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState} returns this
 */
proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState.prototype.setPlayerColor = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int32 left_milliseconds = 2;
 * @return {number}
 */
proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState.prototype.getLeftMilliseconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState} returns this
 */
proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState.prototype.setLeftMilliseconds = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool visible = 3;
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState.prototype.getVisible = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState} returns this
 */
proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState.prototype.setVisible = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool freeze = 4;
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState.prototype.getFreeze = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState} returns this
 */
proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState.prototype.setFreeze = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional FreezeReason freeze_reason = 5;
 * @return {!proto.ccgames.boardgame.Rts.ClockExtension.FreezeReason}
 */
proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState.prototype.getFreezeReason = function() {
  return /** @type {!proto.ccgames.boardgame.Rts.ClockExtension.FreezeReason} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.ccgames.boardgame.Rts.ClockExtension.FreezeReason} value
 * @return {!proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState} returns this
 */
proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState.prototype.setFreezeReason = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.FirebaseExtension.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.FirebaseExtension.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.FirebaseExtension} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.FirebaseExtension.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.FirebaseExtension}
 */
proto.ccgames.boardgame.Rts.FirebaseExtension.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.FirebaseExtension;
  return proto.ccgames.boardgame.Rts.FirebaseExtension.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.FirebaseExtension} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.FirebaseExtension}
 */
proto.ccgames.boardgame.Rts.FirebaseExtension.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.FirebaseExtension.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.FirebaseExtension.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.FirebaseExtension} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.FirebaseExtension.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.FirebaseExtension.Action.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.FirebaseExtension.Action.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.FirebaseExtension.Action} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.FirebaseExtension.Action.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.FirebaseExtension.Action}
 */
proto.ccgames.boardgame.Rts.FirebaseExtension.Action.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.FirebaseExtension.Action;
  return proto.ccgames.boardgame.Rts.FirebaseExtension.Action.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.FirebaseExtension.Action} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.FirebaseExtension.Action}
 */
proto.ccgames.boardgame.Rts.FirebaseExtension.Action.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.FirebaseExtension.Action.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.FirebaseExtension.Action.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.FirebaseExtension.Action} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.FirebaseExtension.Action.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer.toObject = function(includeInstance, msg) {
  var f, obj = {
    playerColor: jspb.Message.getFieldWithDefault(msg, 1, 0),
    firebaseId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    avatarId: jspb.Message.getFieldWithDefault(msg, 4, 0),
    countryCode: jspb.Message.getFieldWithDefault(msg, 5, ""),
    vip: jspb.Message.getBooleanFieldWithDefault(msg, 6, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer}
 */
proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer;
  return proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer}
 */
proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ccgames.boardgame.Game.PlayerColor} */ (reader.readEnum());
      msg.setPlayerColor(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirebaseId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAvatarId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountryCode(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVip(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlayerColor();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getFirebaseId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAvatarId();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getCountryCode();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getVip();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * optional Game.PlayerColor player_color = 1;
 * @return {!proto.ccgames.boardgame.Game.PlayerColor}
 */
proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer.prototype.getPlayerColor = function() {
  return /** @type {!proto.ccgames.boardgame.Game.PlayerColor} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ccgames.boardgame.Game.PlayerColor} value
 * @return {!proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer} returns this
 */
proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer.prototype.setPlayerColor = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string firebase_id = 2;
 * @return {string}
 */
proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer.prototype.getFirebaseId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer} returns this
 */
proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer.prototype.setFirebaseId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer} returns this
 */
proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 avatar_id = 4;
 * @return {number}
 */
proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer.prototype.getAvatarId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer} returns this
 */
proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer.prototype.setAvatarId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string country_code = 5;
 * @return {string}
 */
proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer.prototype.getCountryCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer} returns this
 */
proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer.prototype.setCountryCode = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool vip = 6;
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer.prototype.getVip = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer} returns this
 */
proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer.prototype.setVip = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.TournamentExtension.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.TournamentExtension.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.TournamentExtension} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.TournamentExtension.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.TournamentExtension}
 */
proto.ccgames.boardgame.Rts.TournamentExtension.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.TournamentExtension;
  return proto.ccgames.boardgame.Rts.TournamentExtension.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.TournamentExtension} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.TournamentExtension}
 */
proto.ccgames.boardgame.Rts.TournamentExtension.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.TournamentExtension.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.TournamentExtension.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.TournamentExtension} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.TournamentExtension.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem}
 */
proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem;
  return proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem}
 */
proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress.toObject = function(includeInstance, msg) {
  var f, obj = {
    leaderboardPosition: (f = msg.getLeaderboardPosition()) && proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter.toObject(includeInstance, f),
    score: (f = msg.getScore()) && proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress}
 */
proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress;
  return proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress}
 */
proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter;
      reader.readMessage(value,proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter.deserializeBinaryFromReader);
      msg.setLeaderboardPosition(value);
      break;
    case 2:
      var value = new proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter;
      reader.readMessage(value,proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter.deserializeBinaryFromReader);
      msg.setScore(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLeaderboardPosition();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter.serializeBinaryToWriter
    );
  }
  f = message.getScore();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter.serializeBinaryToWriter
    );
  }
};


/**
 * optional Action.ShowSummary.Counter leaderboard_position = 1;
 * @return {?proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter}
 */
proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress.prototype.getLeaderboardPosition = function() {
  return /** @type{?proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter, 1));
};


/**
 * @param {?proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter|undefined} value
 * @return {!proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress} returns this
*/
proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress.prototype.setLeaderboardPosition = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress} returns this
 */
proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress.prototype.clearLeaderboardPosition = function() {
  return this.setLeaderboardPosition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress.prototype.hasLeaderboardPosition = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Action.ShowSummary.Counter score = 2;
 * @return {?proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter}
 */
proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress.prototype.getScore = function() {
  return /** @type{?proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter, 2));
};


/**
 * @param {?proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter|undefined} value
 * @return {!proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress} returns this
*/
proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress.prototype.setScore = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress} returns this
 */
proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress.prototype.clearScore = function() {
  return this.setScore(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress.prototype.hasScore = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.TournamentExtension.Action.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.TournamentExtension.Action.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.TournamentExtension.Action} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.TournamentExtension.Action.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.TournamentExtension.Action}
 */
proto.ccgames.boardgame.Rts.TournamentExtension.Action.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.TournamentExtension.Action;
  return proto.ccgames.boardgame.Rts.TournamentExtension.Action.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.TournamentExtension.Action} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.TournamentExtension.Action}
 */
proto.ccgames.boardgame.Rts.TournamentExtension.Action.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.TournamentExtension.Action.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.TournamentExtension.Action.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.TournamentExtension.Action} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.TournamentExtension.Action.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetPlayerProgress.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetPlayerProgress.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetPlayerProgress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetPlayerProgress.toObject = function(includeInstance, msg) {
  var f, obj = {
    playerColor: jspb.Message.getFieldWithDefault(msg, 1, 0),
    rank: jspb.Message.getFieldWithDefault(msg, 2, 0),
    score: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetPlayerProgress}
 */
proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetPlayerProgress.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetPlayerProgress;
  return proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetPlayerProgress.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetPlayerProgress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetPlayerProgress}
 */
proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetPlayerProgress.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ccgames.boardgame.Game.PlayerColor} */ (reader.readEnum());
      msg.setPlayerColor(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRank(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setScore(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetPlayerProgress.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetPlayerProgress.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetPlayerProgress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetPlayerProgress.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlayerColor();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getRank();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getScore();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional Game.PlayerColor player_color = 1;
 * @return {!proto.ccgames.boardgame.Game.PlayerColor}
 */
proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetPlayerProgress.prototype.getPlayerColor = function() {
  return /** @type {!proto.ccgames.boardgame.Game.PlayerColor} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ccgames.boardgame.Game.PlayerColor} value
 * @return {!proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetPlayerProgress} returns this
 */
proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetPlayerProgress.prototype.setPlayerColor = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int64 rank = 2;
 * @return {number}
 */
proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetPlayerProgress.prototype.getRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetPlayerProgress} returns this
 */
proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetPlayerProgress.prototype.setRank = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 score = 3;
 * @return {number}
 */
proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetPlayerProgress.prototype.getScore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetPlayerProgress} returns this
 */
proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetPlayerProgress.prototype.setScore = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetTournamentClock.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetTournamentClock.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetTournamentClock} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetTournamentClock.toObject = function(includeInstance, msg) {
  var f, obj = {
    leftMilliseconds: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetTournamentClock}
 */
proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetTournamentClock.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetTournamentClock;
  return proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetTournamentClock.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetTournamentClock} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetTournamentClock}
 */
proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetTournamentClock.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLeftMilliseconds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetTournamentClock.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetTournamentClock.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetTournamentClock} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetTournamentClock.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLeftMilliseconds();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 left_milliseconds = 2;
 * @return {number}
 */
proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetTournamentClock.prototype.getLeftMilliseconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetTournamentClock} returns this
 */
proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetTournamentClock.prototype.setLeftMilliseconds = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.EloRankingExtension.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.EloRankingExtension} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.EloRankingExtension}
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.EloRankingExtension;
  return proto.ccgames.boardgame.Rts.EloRankingExtension.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.EloRankingExtension} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.EloRankingExtension}
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.EloRankingExtension.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.EloRankingExtension} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem}
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem;
  return proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem}
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.EloProgress.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.EloProgress.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.EloProgress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.EloProgress.toObject = function(includeInstance, msg) {
  var f, obj = {
    elo: (f = msg.getElo()) && proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.EloProgress}
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.EloProgress.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.EloProgress;
  return proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.EloProgress.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.EloProgress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.EloProgress}
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.EloProgress.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter;
      reader.readMessage(value,proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter.deserializeBinaryFromReader);
      msg.setElo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.EloProgress.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.EloProgress.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.EloProgress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.EloProgress.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getElo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter.serializeBinaryToWriter
    );
  }
};


/**
 * optional Action.ShowSummary.Counter elo = 1;
 * @return {?proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter}
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.EloProgress.prototype.getElo = function() {
  return /** @type{?proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter, 1));
};


/**
 * @param {?proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter|undefined} value
 * @return {!proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.EloProgress} returns this
*/
proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.EloProgress.prototype.setElo = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.EloProgress} returns this
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.EloProgress.prototype.clearElo = function() {
  return this.setElo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.EloProgress.prototype.hasElo = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.Action.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.EloRankingExtension.Action.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.EloRankingExtension.Action} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.Action.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.EloRankingExtension.Action}
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.Action.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.EloRankingExtension.Action;
  return proto.ccgames.boardgame.Rts.EloRankingExtension.Action.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.EloRankingExtension.Action} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.EloRankingExtension.Action}
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.Action.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.Action.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.EloRankingExtension.Action.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.EloRankingExtension.Action} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.Action.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.Action.SetPlayerElo.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.EloRankingExtension.Action.SetPlayerElo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.EloRankingExtension.Action.SetPlayerElo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.Action.SetPlayerElo.toObject = function(includeInstance, msg) {
  var f, obj = {
    playerColor: jspb.Message.getFieldWithDefault(msg, 1, 0),
    elo: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.EloRankingExtension.Action.SetPlayerElo}
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.Action.SetPlayerElo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.EloRankingExtension.Action.SetPlayerElo;
  return proto.ccgames.boardgame.Rts.EloRankingExtension.Action.SetPlayerElo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.EloRankingExtension.Action.SetPlayerElo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.EloRankingExtension.Action.SetPlayerElo}
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.Action.SetPlayerElo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ccgames.boardgame.Game.PlayerColor} */ (reader.readEnum());
      msg.setPlayerColor(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setElo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.Action.SetPlayerElo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.EloRankingExtension.Action.SetPlayerElo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.EloRankingExtension.Action.SetPlayerElo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.Action.SetPlayerElo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlayerColor();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getElo();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional Game.PlayerColor player_color = 1;
 * @return {!proto.ccgames.boardgame.Game.PlayerColor}
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.Action.SetPlayerElo.prototype.getPlayerColor = function() {
  return /** @type {!proto.ccgames.boardgame.Game.PlayerColor} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ccgames.boardgame.Game.PlayerColor} value
 * @return {!proto.ccgames.boardgame.Rts.EloRankingExtension.Action.SetPlayerElo} returns this
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.Action.SetPlayerElo.prototype.setPlayerColor = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int32 elo = 2;
 * @return {number}
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.Action.SetPlayerElo.prototype.getElo = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ccgames.boardgame.Rts.EloRankingExtension.Action.SetPlayerElo} returns this
 */
proto.ccgames.boardgame.Rts.EloRankingExtension.Action.SetPlayerElo.prototype.setElo = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.OnboardingExtension.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.OnboardingExtension.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.OnboardingExtension} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.OnboardingExtension.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.OnboardingExtension}
 */
proto.ccgames.boardgame.Rts.OnboardingExtension.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.OnboardingExtension;
  return proto.ccgames.boardgame.Rts.OnboardingExtension.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.OnboardingExtension} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.OnboardingExtension}
 */
proto.ccgames.boardgame.Rts.OnboardingExtension.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.OnboardingExtension.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.OnboardingExtension.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.OnboardingExtension} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.OnboardingExtension.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem}
 */
proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem;
  return proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem}
 */
proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingProgress.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingProgress.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingProgress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingProgress.toObject = function(includeInstance, msg) {
  var f, obj = {
    completedGames: jspb.Message.getFieldWithDefault(msg, 1, 0),
    totalGames: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingProgress}
 */
proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingProgress.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingProgress;
  return proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingProgress.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingProgress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingProgress}
 */
proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingProgress.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCompletedGames(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalGames(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingProgress.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingProgress.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingProgress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingProgress.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompletedGames();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTotalGames();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 completed_games = 1;
 * @return {number}
 */
proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingProgress.prototype.getCompletedGames = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingProgress} returns this
 */
proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingProgress.prototype.setCompletedGames = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 total_games = 2;
 * @return {number}
 */
proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingProgress.prototype.getTotalGames = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingProgress} returns this
 */
proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingProgress.prototype.setTotalGames = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingResult.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    elo: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingResult}
 */
proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingResult;
  return proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingResult}
 */
proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setElo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getElo();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 elo = 1;
 * @return {number}
 */
proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingResult.prototype.getElo = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingResult} returns this
 */
proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingResult.prototype.setElo = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.Error.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.Error.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.Error} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.Error.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    message: jspb.Message.getFieldWithDefault(msg, 2, ""),
    causeRequest: (f = msg.getCauseRequest()) && proto.ccgames.boardgame.Rts.Request.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.Error}
 */
proto.ccgames.boardgame.Rts.Error.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.Error;
  return proto.ccgames.boardgame.Rts.Error.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.Error} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.Error}
 */
proto.ccgames.boardgame.Rts.Error.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ccgames.boardgame.Rts.Error.Code} */ (reader.readEnum());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 3:
      var value = new proto.ccgames.boardgame.Rts.Request;
      reader.readMessage(value,proto.ccgames.boardgame.Rts.Request.deserializeBinaryFromReader);
      msg.setCauseRequest(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.Error.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.Error.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.Error} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.Error.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCauseRequest();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ccgames.boardgame.Rts.Request.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.ccgames.boardgame.Rts.Error.Code = {
  UNDEFINED: 0,
  REQUEST_REJECTED: 401,
  NOT_A_PARTICIPANT: 402,
  INTERNAL_ERROR: 500,
  REQUEST_NOT_SUPPORTED: 501
};

/**
 * optional Code code = 1;
 * @return {!proto.ccgames.boardgame.Rts.Error.Code}
 */
proto.ccgames.boardgame.Rts.Error.prototype.getCode = function() {
  return /** @type {!proto.ccgames.boardgame.Rts.Error.Code} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ccgames.boardgame.Rts.Error.Code} value
 * @return {!proto.ccgames.boardgame.Rts.Error} returns this
 */
proto.ccgames.boardgame.Rts.Error.prototype.setCode = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.ccgames.boardgame.Rts.Error.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ccgames.boardgame.Rts.Error} returns this
 */
proto.ccgames.boardgame.Rts.Error.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Request cause_request = 3;
 * @return {?proto.ccgames.boardgame.Rts.Request}
 */
proto.ccgames.boardgame.Rts.Error.prototype.getCauseRequest = function() {
  return /** @type{?proto.ccgames.boardgame.Rts.Request} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Rts.Request, 3));
};


/**
 * @param {?proto.ccgames.boardgame.Rts.Request|undefined} value
 * @return {!proto.ccgames.boardgame.Rts.Error} returns this
*/
proto.ccgames.boardgame.Rts.Error.prototype.setCauseRequest = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Rts.Error} returns this
 */
proto.ccgames.boardgame.Rts.Error.prototype.clearCauseRequest = function() {
  return this.setCauseRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.Error.prototype.hasCauseRequest = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.ccgames.boardgame.Rts.Request.oneofGroups_ = [[1,2,11,12,13,14]];

/**
 * @enum {number}
 */
proto.ccgames.boardgame.Rts.Request.RequestOneofCase = {
  REQUEST_ONEOF_NOT_SET: 0,
  MAKE_MOVE: 1,
  SURRENDER: 2,
  PROPOSE_DRAW: 11,
  ACCEPT_DRAW: 12,
  REJECT_DRAW: 13,
  RTS_GAME_CONFIRM_READINESS: 14
};

/**
 * @return {proto.ccgames.boardgame.Rts.Request.RequestOneofCase}
 */
proto.ccgames.boardgame.Rts.Request.prototype.getRequestOneofCase = function() {
  return /** @type {proto.ccgames.boardgame.Rts.Request.RequestOneofCase} */(jspb.Message.computeOneofCase(this, proto.ccgames.boardgame.Rts.Request.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    makeMove: (f = msg.getMakeMove()) && proto.ccgames.boardgame.Rts.Request.MakeMove.toObject(includeInstance, f),
    surrender: (f = msg.getSurrender()) && proto.ccgames.boardgame.Rts.SurrenderExtension.Request.Surrender.toObject(includeInstance, f),
    proposeDraw: (f = msg.getProposeDraw()) && proto.ccgames.boardgame.Rts.DrawExtension.Request.ProposeDraw.toObject(includeInstance, f),
    acceptDraw: (f = msg.getAcceptDraw()) && proto.ccgames.boardgame.Rts.DrawExtension.Request.AcceptDraw.toObject(includeInstance, f),
    rejectDraw: (f = msg.getRejectDraw()) && proto.ccgames.boardgame.Rts.DrawExtension.Request.RejectDraw.toObject(includeInstance, f),
    rtsGameConfirmReadiness: (f = msg.getRtsGameConfirmReadiness()) && proto.ccgames.boardgame.Rts.Request.ConfirmReadiness.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.Request}
 */
proto.ccgames.boardgame.Rts.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.Request;
  return proto.ccgames.boardgame.Rts.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.Request}
 */
proto.ccgames.boardgame.Rts.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ccgames.boardgame.Rts.Request.MakeMove;
      reader.readMessage(value,proto.ccgames.boardgame.Rts.Request.MakeMove.deserializeBinaryFromReader);
      msg.setMakeMove(value);
      break;
    case 2:
      var value = new proto.ccgames.boardgame.Rts.SurrenderExtension.Request.Surrender;
      reader.readMessage(value,proto.ccgames.boardgame.Rts.SurrenderExtension.Request.Surrender.deserializeBinaryFromReader);
      msg.setSurrender(value);
      break;
    case 11:
      var value = new proto.ccgames.boardgame.Rts.DrawExtension.Request.ProposeDraw;
      reader.readMessage(value,proto.ccgames.boardgame.Rts.DrawExtension.Request.ProposeDraw.deserializeBinaryFromReader);
      msg.setProposeDraw(value);
      break;
    case 12:
      var value = new proto.ccgames.boardgame.Rts.DrawExtension.Request.AcceptDraw;
      reader.readMessage(value,proto.ccgames.boardgame.Rts.DrawExtension.Request.AcceptDraw.deserializeBinaryFromReader);
      msg.setAcceptDraw(value);
      break;
    case 13:
      var value = new proto.ccgames.boardgame.Rts.DrawExtension.Request.RejectDraw;
      reader.readMessage(value,proto.ccgames.boardgame.Rts.DrawExtension.Request.RejectDraw.deserializeBinaryFromReader);
      msg.setRejectDraw(value);
      break;
    case 14:
      var value = new proto.ccgames.boardgame.Rts.Request.ConfirmReadiness;
      reader.readMessage(value,proto.ccgames.boardgame.Rts.Request.ConfirmReadiness.deserializeBinaryFromReader);
      msg.setRtsGameConfirmReadiness(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMakeMove();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ccgames.boardgame.Rts.Request.MakeMove.serializeBinaryToWriter
    );
  }
  f = message.getSurrender();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ccgames.boardgame.Rts.SurrenderExtension.Request.Surrender.serializeBinaryToWriter
    );
  }
  f = message.getProposeDraw();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.ccgames.boardgame.Rts.DrawExtension.Request.ProposeDraw.serializeBinaryToWriter
    );
  }
  f = message.getAcceptDraw();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.ccgames.boardgame.Rts.DrawExtension.Request.AcceptDraw.serializeBinaryToWriter
    );
  }
  f = message.getRejectDraw();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.ccgames.boardgame.Rts.DrawExtension.Request.RejectDraw.serializeBinaryToWriter
    );
  }
  f = message.getRtsGameConfirmReadiness();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.ccgames.boardgame.Rts.Request.ConfirmReadiness.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.Request.ConfirmReadiness.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.Request.ConfirmReadiness.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.Request.ConfirmReadiness} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.Request.ConfirmReadiness.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.Request.ConfirmReadiness}
 */
proto.ccgames.boardgame.Rts.Request.ConfirmReadiness.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.Request.ConfirmReadiness;
  return proto.ccgames.boardgame.Rts.Request.ConfirmReadiness.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.Request.ConfirmReadiness} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.Request.ConfirmReadiness}
 */
proto.ccgames.boardgame.Rts.Request.ConfirmReadiness.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.Request.ConfirmReadiness.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.Request.ConfirmReadiness.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.Request.ConfirmReadiness} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.Request.ConfirmReadiness.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.Request.MakeMove.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.Request.MakeMove.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.Request.MakeMove} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.Request.MakeMove.toObject = function(includeInstance, msg) {
  var f, obj = {
    moveCode: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.Request.MakeMove}
 */
proto.ccgames.boardgame.Rts.Request.MakeMove.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.Request.MakeMove;
  return proto.ccgames.boardgame.Rts.Request.MakeMove.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.Request.MakeMove} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.Request.MakeMove}
 */
proto.ccgames.boardgame.Rts.Request.MakeMove.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMoveCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.Request.MakeMove.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.Request.MakeMove.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.Request.MakeMove} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.Request.MakeMove.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMoveCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string move_code = 1;
 * @return {string}
 */
proto.ccgames.boardgame.Rts.Request.MakeMove.prototype.getMoveCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ccgames.boardgame.Rts.Request.MakeMove} returns this
 */
proto.ccgames.boardgame.Rts.Request.MakeMove.prototype.setMoveCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional MakeMove make_move = 1;
 * @return {?proto.ccgames.boardgame.Rts.Request.MakeMove}
 */
proto.ccgames.boardgame.Rts.Request.prototype.getMakeMove = function() {
  return /** @type{?proto.ccgames.boardgame.Rts.Request.MakeMove} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Rts.Request.MakeMove, 1));
};


/**
 * @param {?proto.ccgames.boardgame.Rts.Request.MakeMove|undefined} value
 * @return {!proto.ccgames.boardgame.Rts.Request} returns this
*/
proto.ccgames.boardgame.Rts.Request.prototype.setMakeMove = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.ccgames.boardgame.Rts.Request.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Rts.Request} returns this
 */
proto.ccgames.boardgame.Rts.Request.prototype.clearMakeMove = function() {
  return this.setMakeMove(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.Request.prototype.hasMakeMove = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SurrenderExtension.Request.Surrender surrender = 2;
 * @return {?proto.ccgames.boardgame.Rts.SurrenderExtension.Request.Surrender}
 */
proto.ccgames.boardgame.Rts.Request.prototype.getSurrender = function() {
  return /** @type{?proto.ccgames.boardgame.Rts.SurrenderExtension.Request.Surrender} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Rts.SurrenderExtension.Request.Surrender, 2));
};


/**
 * @param {?proto.ccgames.boardgame.Rts.SurrenderExtension.Request.Surrender|undefined} value
 * @return {!proto.ccgames.boardgame.Rts.Request} returns this
*/
proto.ccgames.boardgame.Rts.Request.prototype.setSurrender = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.ccgames.boardgame.Rts.Request.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Rts.Request} returns this
 */
proto.ccgames.boardgame.Rts.Request.prototype.clearSurrender = function() {
  return this.setSurrender(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.Request.prototype.hasSurrender = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional DrawExtension.Request.ProposeDraw propose_draw = 11;
 * @return {?proto.ccgames.boardgame.Rts.DrawExtension.Request.ProposeDraw}
 */
proto.ccgames.boardgame.Rts.Request.prototype.getProposeDraw = function() {
  return /** @type{?proto.ccgames.boardgame.Rts.DrawExtension.Request.ProposeDraw} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Rts.DrawExtension.Request.ProposeDraw, 11));
};


/**
 * @param {?proto.ccgames.boardgame.Rts.DrawExtension.Request.ProposeDraw|undefined} value
 * @return {!proto.ccgames.boardgame.Rts.Request} returns this
*/
proto.ccgames.boardgame.Rts.Request.prototype.setProposeDraw = function(value) {
  return jspb.Message.setOneofWrapperField(this, 11, proto.ccgames.boardgame.Rts.Request.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Rts.Request} returns this
 */
proto.ccgames.boardgame.Rts.Request.prototype.clearProposeDraw = function() {
  return this.setProposeDraw(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.Request.prototype.hasProposeDraw = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional DrawExtension.Request.AcceptDraw accept_draw = 12;
 * @return {?proto.ccgames.boardgame.Rts.DrawExtension.Request.AcceptDraw}
 */
proto.ccgames.boardgame.Rts.Request.prototype.getAcceptDraw = function() {
  return /** @type{?proto.ccgames.boardgame.Rts.DrawExtension.Request.AcceptDraw} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Rts.DrawExtension.Request.AcceptDraw, 12));
};


/**
 * @param {?proto.ccgames.boardgame.Rts.DrawExtension.Request.AcceptDraw|undefined} value
 * @return {!proto.ccgames.boardgame.Rts.Request} returns this
*/
proto.ccgames.boardgame.Rts.Request.prototype.setAcceptDraw = function(value) {
  return jspb.Message.setOneofWrapperField(this, 12, proto.ccgames.boardgame.Rts.Request.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Rts.Request} returns this
 */
proto.ccgames.boardgame.Rts.Request.prototype.clearAcceptDraw = function() {
  return this.setAcceptDraw(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.Request.prototype.hasAcceptDraw = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional DrawExtension.Request.RejectDraw reject_draw = 13;
 * @return {?proto.ccgames.boardgame.Rts.DrawExtension.Request.RejectDraw}
 */
proto.ccgames.boardgame.Rts.Request.prototype.getRejectDraw = function() {
  return /** @type{?proto.ccgames.boardgame.Rts.DrawExtension.Request.RejectDraw} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Rts.DrawExtension.Request.RejectDraw, 13));
};


/**
 * @param {?proto.ccgames.boardgame.Rts.DrawExtension.Request.RejectDraw|undefined} value
 * @return {!proto.ccgames.boardgame.Rts.Request} returns this
*/
proto.ccgames.boardgame.Rts.Request.prototype.setRejectDraw = function(value) {
  return jspb.Message.setOneofWrapperField(this, 13, proto.ccgames.boardgame.Rts.Request.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Rts.Request} returns this
 */
proto.ccgames.boardgame.Rts.Request.prototype.clearRejectDraw = function() {
  return this.setRejectDraw(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.Request.prototype.hasRejectDraw = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional ConfirmReadiness rts_game_confirm_readiness = 14;
 * @return {?proto.ccgames.boardgame.Rts.Request.ConfirmReadiness}
 */
proto.ccgames.boardgame.Rts.Request.prototype.getRtsGameConfirmReadiness = function() {
  return /** @type{?proto.ccgames.boardgame.Rts.Request.ConfirmReadiness} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Rts.Request.ConfirmReadiness, 14));
};


/**
 * @param {?proto.ccgames.boardgame.Rts.Request.ConfirmReadiness|undefined} value
 * @return {!proto.ccgames.boardgame.Rts.Request} returns this
*/
proto.ccgames.boardgame.Rts.Request.prototype.setRtsGameConfirmReadiness = function(value) {
  return jspb.Message.setOneofWrapperField(this, 14, proto.ccgames.boardgame.Rts.Request.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Rts.Request} returns this
 */
proto.ccgames.boardgame.Rts.Request.prototype.clearRtsGameConfirmReadiness = function() {
  return this.setRtsGameConfirmReadiness(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.Request.prototype.hasRtsGameConfirmReadiness = function() {
  return jspb.Message.getField(this, 14) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.ccgames.boardgame.Rts.Action.oneofGroups_ = [[1,2,3,4,5,6,10,11,12,13,14,15,16,17,18,19,20]];

/**
 * @enum {number}
 */
proto.ccgames.boardgame.Rts.Action.ActionOneofCase = {
  ACTION_ONEOF_NOT_SET: 0,
  MOVE: 1,
  SET_AVAILABLE_MOVES: 2,
  SET_SIDE_TO_MOVE: 3,
  INIT_BOARD: 4,
  HIGHLIGHT: 5,
  REVOKE_HIGHLIGHT: 6,
  SET_DRAW_STATE: 10,
  SET_FIREBASE_PLAYER: 11,
  SET_PLAYER_CLOCK_STATE: 12,
  SET_GAME_STATE: 13,
  ACTIVATE_GAME: 14,
  COMPLETE_GAME: 15,
  SET_ANONYMOUS_PLAYER: 16,
  SHOW_SUMMARY: 17,
  SET_TOURNAMENT_PLAYER_PROGRESS: 18,
  SET_TOURNAMENT_CLOCK: 19,
  SET_PLAYER_ELO: 20
};

/**
 * @return {proto.ccgames.boardgame.Rts.Action.ActionOneofCase}
 */
proto.ccgames.boardgame.Rts.Action.prototype.getActionOneofCase = function() {
  return /** @type {proto.ccgames.boardgame.Rts.Action.ActionOneofCase} */(jspb.Message.computeOneofCase(this, proto.ccgames.boardgame.Rts.Action.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.Action.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.Action.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.Action} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.Action.toObject = function(includeInstance, msg) {
  var f, obj = {
    move: (f = msg.getMove()) && proto.ccgames.boardgame.Arbiter.Action.Move.toObject(includeInstance, f),
    setAvailableMoves: (f = msg.getSetAvailableMoves()) && proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves.toObject(includeInstance, f),
    setSideToMove: (f = msg.getSetSideToMove()) && proto.ccgames.boardgame.Arbiter.Action.SetSideToMove.toObject(includeInstance, f),
    initBoard: (f = msg.getInitBoard()) && proto.ccgames.boardgame.Arbiter.Action.InitBoard.toObject(includeInstance, f),
    highlight: (f = msg.getHighlight()) && proto.ccgames.boardgame.Arbiter.Action.Highlight.toObject(includeInstance, f),
    revokeHighlight: (f = msg.getRevokeHighlight()) && proto.ccgames.boardgame.Arbiter.Action.RevokeHighlight.toObject(includeInstance, f),
    setDrawState: (f = msg.getSetDrawState()) && proto.ccgames.boardgame.Rts.DrawExtension.Action.SetDrawState.toObject(includeInstance, f),
    setFirebasePlayer: (f = msg.getSetFirebasePlayer()) && proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer.toObject(includeInstance, f),
    setPlayerClockState: (f = msg.getSetPlayerClockState()) && proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState.toObject(includeInstance, f),
    setGameState: (f = msg.getSetGameState()) && proto.ccgames.boardgame.Rts.Action.SetGameState.toObject(includeInstance, f),
    activateGame: (f = msg.getActivateGame()) && proto.ccgames.boardgame.Rts.Action.ActivateGame.toObject(includeInstance, f),
    completeGame: (f = msg.getCompleteGame()) && proto.ccgames.boardgame.Rts.Action.CompleteGame.toObject(includeInstance, f),
    setAnonymousPlayer: (f = msg.getSetAnonymousPlayer()) && proto.ccgames.boardgame.Rts.Action.SetAnonymousPlayer.toObject(includeInstance, f),
    showSummary: (f = msg.getShowSummary()) && proto.ccgames.boardgame.Rts.Action.ShowSummary.toObject(includeInstance, f),
    setTournamentPlayerProgress: (f = msg.getSetTournamentPlayerProgress()) && proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetPlayerProgress.toObject(includeInstance, f),
    setTournamentClock: (f = msg.getSetTournamentClock()) && proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetTournamentClock.toObject(includeInstance, f),
    setPlayerElo: (f = msg.getSetPlayerElo()) && proto.ccgames.boardgame.Rts.EloRankingExtension.Action.SetPlayerElo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.Action}
 */
proto.ccgames.boardgame.Rts.Action.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.Action;
  return proto.ccgames.boardgame.Rts.Action.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.Action} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.Action}
 */
proto.ccgames.boardgame.Rts.Action.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ccgames.boardgame.Arbiter.Action.Move;
      reader.readMessage(value,proto.ccgames.boardgame.Arbiter.Action.Move.deserializeBinaryFromReader);
      msg.setMove(value);
      break;
    case 2:
      var value = new proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves;
      reader.readMessage(value,proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves.deserializeBinaryFromReader);
      msg.setSetAvailableMoves(value);
      break;
    case 3:
      var value = new proto.ccgames.boardgame.Arbiter.Action.SetSideToMove;
      reader.readMessage(value,proto.ccgames.boardgame.Arbiter.Action.SetSideToMove.deserializeBinaryFromReader);
      msg.setSetSideToMove(value);
      break;
    case 4:
      var value = new proto.ccgames.boardgame.Arbiter.Action.InitBoard;
      reader.readMessage(value,proto.ccgames.boardgame.Arbiter.Action.InitBoard.deserializeBinaryFromReader);
      msg.setInitBoard(value);
      break;
    case 5:
      var value = new proto.ccgames.boardgame.Arbiter.Action.Highlight;
      reader.readMessage(value,proto.ccgames.boardgame.Arbiter.Action.Highlight.deserializeBinaryFromReader);
      msg.setHighlight(value);
      break;
    case 6:
      var value = new proto.ccgames.boardgame.Arbiter.Action.RevokeHighlight;
      reader.readMessage(value,proto.ccgames.boardgame.Arbiter.Action.RevokeHighlight.deserializeBinaryFromReader);
      msg.setRevokeHighlight(value);
      break;
    case 10:
      var value = new proto.ccgames.boardgame.Rts.DrawExtension.Action.SetDrawState;
      reader.readMessage(value,proto.ccgames.boardgame.Rts.DrawExtension.Action.SetDrawState.deserializeBinaryFromReader);
      msg.setSetDrawState(value);
      break;
    case 11:
      var value = new proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer;
      reader.readMessage(value,proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer.deserializeBinaryFromReader);
      msg.setSetFirebasePlayer(value);
      break;
    case 12:
      var value = new proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState;
      reader.readMessage(value,proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState.deserializeBinaryFromReader);
      msg.setSetPlayerClockState(value);
      break;
    case 13:
      var value = new proto.ccgames.boardgame.Rts.Action.SetGameState;
      reader.readMessage(value,proto.ccgames.boardgame.Rts.Action.SetGameState.deserializeBinaryFromReader);
      msg.setSetGameState(value);
      break;
    case 14:
      var value = new proto.ccgames.boardgame.Rts.Action.ActivateGame;
      reader.readMessage(value,proto.ccgames.boardgame.Rts.Action.ActivateGame.deserializeBinaryFromReader);
      msg.setActivateGame(value);
      break;
    case 15:
      var value = new proto.ccgames.boardgame.Rts.Action.CompleteGame;
      reader.readMessage(value,proto.ccgames.boardgame.Rts.Action.CompleteGame.deserializeBinaryFromReader);
      msg.setCompleteGame(value);
      break;
    case 16:
      var value = new proto.ccgames.boardgame.Rts.Action.SetAnonymousPlayer;
      reader.readMessage(value,proto.ccgames.boardgame.Rts.Action.SetAnonymousPlayer.deserializeBinaryFromReader);
      msg.setSetAnonymousPlayer(value);
      break;
    case 17:
      var value = new proto.ccgames.boardgame.Rts.Action.ShowSummary;
      reader.readMessage(value,proto.ccgames.boardgame.Rts.Action.ShowSummary.deserializeBinaryFromReader);
      msg.setShowSummary(value);
      break;
    case 18:
      var value = new proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetPlayerProgress;
      reader.readMessage(value,proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetPlayerProgress.deserializeBinaryFromReader);
      msg.setSetTournamentPlayerProgress(value);
      break;
    case 19:
      var value = new proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetTournamentClock;
      reader.readMessage(value,proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetTournamentClock.deserializeBinaryFromReader);
      msg.setSetTournamentClock(value);
      break;
    case 20:
      var value = new proto.ccgames.boardgame.Rts.EloRankingExtension.Action.SetPlayerElo;
      reader.readMessage(value,proto.ccgames.boardgame.Rts.EloRankingExtension.Action.SetPlayerElo.deserializeBinaryFromReader);
      msg.setSetPlayerElo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.Action.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.Action.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.Action} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.Action.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMove();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ccgames.boardgame.Arbiter.Action.Move.serializeBinaryToWriter
    );
  }
  f = message.getSetAvailableMoves();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves.serializeBinaryToWriter
    );
  }
  f = message.getSetSideToMove();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ccgames.boardgame.Arbiter.Action.SetSideToMove.serializeBinaryToWriter
    );
  }
  f = message.getInitBoard();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.ccgames.boardgame.Arbiter.Action.InitBoard.serializeBinaryToWriter
    );
  }
  f = message.getHighlight();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.ccgames.boardgame.Arbiter.Action.Highlight.serializeBinaryToWriter
    );
  }
  f = message.getRevokeHighlight();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.ccgames.boardgame.Arbiter.Action.RevokeHighlight.serializeBinaryToWriter
    );
  }
  f = message.getSetDrawState();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.ccgames.boardgame.Rts.DrawExtension.Action.SetDrawState.serializeBinaryToWriter
    );
  }
  f = message.getSetFirebasePlayer();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer.serializeBinaryToWriter
    );
  }
  f = message.getSetPlayerClockState();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState.serializeBinaryToWriter
    );
  }
  f = message.getSetGameState();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.ccgames.boardgame.Rts.Action.SetGameState.serializeBinaryToWriter
    );
  }
  f = message.getActivateGame();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.ccgames.boardgame.Rts.Action.ActivateGame.serializeBinaryToWriter
    );
  }
  f = message.getCompleteGame();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      proto.ccgames.boardgame.Rts.Action.CompleteGame.serializeBinaryToWriter
    );
  }
  f = message.getSetAnonymousPlayer();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      proto.ccgames.boardgame.Rts.Action.SetAnonymousPlayer.serializeBinaryToWriter
    );
  }
  f = message.getShowSummary();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      proto.ccgames.boardgame.Rts.Action.ShowSummary.serializeBinaryToWriter
    );
  }
  f = message.getSetTournamentPlayerProgress();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetPlayerProgress.serializeBinaryToWriter
    );
  }
  f = message.getSetTournamentClock();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetTournamentClock.serializeBinaryToWriter
    );
  }
  f = message.getSetPlayerElo();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      proto.ccgames.boardgame.Rts.EloRankingExtension.Action.SetPlayerElo.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.Action.SetGameState.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.Action.SetGameState.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.Action.SetGameState} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.Action.SetGameState.toObject = function(includeInstance, msg) {
  var f, obj = {
    state: jspb.Message.getFieldWithDefault(msg, 1, 0),
    yourColor: jspb.Message.getFieldWithDefault(msg, 2, 0),
    finalSave: (f = msg.getFinalSave()) && proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.Action.SetGameState}
 */
proto.ccgames.boardgame.Rts.Action.SetGameState.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.Action.SetGameState;
  return proto.ccgames.boardgame.Rts.Action.SetGameState.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.Action.SetGameState} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.Action.SetGameState}
 */
proto.ccgames.boardgame.Rts.Action.SetGameState.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ccgames.boardgame.Rts.GameState} */ (reader.readEnum());
      msg.setState(value);
      break;
    case 2:
      var value = /** @type {!proto.ccgames.boardgame.Game.PlayerColor} */ (reader.readEnum());
      msg.setYourColor(value);
      break;
    case 3:
      var value = new proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave;
      reader.readMessage(value,proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave.deserializeBinaryFromReader);
      msg.setFinalSave(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.Action.SetGameState.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.Action.SetGameState.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.Action.SetGameState} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.Action.SetGameState.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getState();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getYourColor();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getFinalSave();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave.toObject = function(includeInstance, msg) {
  var f, obj = {
    result: jspb.Message.getFieldWithDefault(msg, 1, 0),
    resultGenesis: jspb.Message.getFieldWithDefault(msg, 2, 0),
    arbiterGameSave: (f = msg.getArbiterGameSave()) && proto.ccgames.boardgame.Arbiter.GameSave.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave}
 */
proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave;
  return proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave}
 */
proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ccgames.boardgame.Game.Result} */ (reader.readEnum());
      msg.setResult(value);
      break;
    case 2:
      var value = /** @type {!proto.ccgames.boardgame.Game.ResultGenesis} */ (reader.readEnum());
      msg.setResultGenesis(value);
      break;
    case 3:
      var value = new proto.ccgames.boardgame.Arbiter.GameSave;
      reader.readMessage(value,proto.ccgames.boardgame.Arbiter.GameSave.deserializeBinaryFromReader);
      msg.setArbiterGameSave(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResult();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getResultGenesis();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getArbiterGameSave();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ccgames.boardgame.Arbiter.GameSave.serializeBinaryToWriter
    );
  }
};


/**
 * optional Game.Result result = 1;
 * @return {!proto.ccgames.boardgame.Game.Result}
 */
proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave.prototype.getResult = function() {
  return /** @type {!proto.ccgames.boardgame.Game.Result} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ccgames.boardgame.Game.Result} value
 * @return {!proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave} returns this
 */
proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave.prototype.setResult = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional Game.ResultGenesis result_genesis = 2;
 * @return {!proto.ccgames.boardgame.Game.ResultGenesis}
 */
proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave.prototype.getResultGenesis = function() {
  return /** @type {!proto.ccgames.boardgame.Game.ResultGenesis} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.ccgames.boardgame.Game.ResultGenesis} value
 * @return {!proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave} returns this
 */
proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave.prototype.setResultGenesis = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional Arbiter.GameSave arbiter_game_save = 3;
 * @return {?proto.ccgames.boardgame.Arbiter.GameSave}
 */
proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave.prototype.getArbiterGameSave = function() {
  return /** @type{?proto.ccgames.boardgame.Arbiter.GameSave} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Arbiter.GameSave, 3));
};


/**
 * @param {?proto.ccgames.boardgame.Arbiter.GameSave|undefined} value
 * @return {!proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave} returns this
*/
proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave.prototype.setArbiterGameSave = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave} returns this
 */
proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave.prototype.clearArbiterGameSave = function() {
  return this.setArbiterGameSave(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave.prototype.hasArbiterGameSave = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional GameState state = 1;
 * @return {!proto.ccgames.boardgame.Rts.GameState}
 */
proto.ccgames.boardgame.Rts.Action.SetGameState.prototype.getState = function() {
  return /** @type {!proto.ccgames.boardgame.Rts.GameState} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ccgames.boardgame.Rts.GameState} value
 * @return {!proto.ccgames.boardgame.Rts.Action.SetGameState} returns this
 */
proto.ccgames.boardgame.Rts.Action.SetGameState.prototype.setState = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional Game.PlayerColor your_color = 2;
 * @return {!proto.ccgames.boardgame.Game.PlayerColor}
 */
proto.ccgames.boardgame.Rts.Action.SetGameState.prototype.getYourColor = function() {
  return /** @type {!proto.ccgames.boardgame.Game.PlayerColor} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.ccgames.boardgame.Game.PlayerColor} value
 * @return {!proto.ccgames.boardgame.Rts.Action.SetGameState} returns this
 */
proto.ccgames.boardgame.Rts.Action.SetGameState.prototype.setYourColor = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional FinalSave final_save = 3;
 * @return {?proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave}
 */
proto.ccgames.boardgame.Rts.Action.SetGameState.prototype.getFinalSave = function() {
  return /** @type{?proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave, 3));
};


/**
 * @param {?proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave|undefined} value
 * @return {!proto.ccgames.boardgame.Rts.Action.SetGameState} returns this
*/
proto.ccgames.boardgame.Rts.Action.SetGameState.prototype.setFinalSave = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Rts.Action.SetGameState} returns this
 */
proto.ccgames.boardgame.Rts.Action.SetGameState.prototype.clearFinalSave = function() {
  return this.setFinalSave(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.Action.SetGameState.prototype.hasFinalSave = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.Action.ActivateGame.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.Action.ActivateGame.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.Action.ActivateGame} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.Action.ActivateGame.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.Action.ActivateGame}
 */
proto.ccgames.boardgame.Rts.Action.ActivateGame.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.Action.ActivateGame;
  return proto.ccgames.boardgame.Rts.Action.ActivateGame.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.Action.ActivateGame} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.Action.ActivateGame}
 */
proto.ccgames.boardgame.Rts.Action.ActivateGame.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.Action.ActivateGame.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.Action.ActivateGame.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.Action.ActivateGame} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.Action.ActivateGame.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.Action.CompleteGame.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.Action.CompleteGame.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.Action.CompleteGame} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.Action.CompleteGame.toObject = function(includeInstance, msg) {
  var f, obj = {
    finalSave: (f = msg.getFinalSave()) && proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.Action.CompleteGame}
 */
proto.ccgames.boardgame.Rts.Action.CompleteGame.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.Action.CompleteGame;
  return proto.ccgames.boardgame.Rts.Action.CompleteGame.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.Action.CompleteGame} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.Action.CompleteGame}
 */
proto.ccgames.boardgame.Rts.Action.CompleteGame.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave;
      reader.readMessage(value,proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave.deserializeBinaryFromReader);
      msg.setFinalSave(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.Action.CompleteGame.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.Action.CompleteGame.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.Action.CompleteGame} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.Action.CompleteGame.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFinalSave();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave.serializeBinaryToWriter
    );
  }
};


/**
 * optional SetGameState.FinalSave final_save = 1;
 * @return {?proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave}
 */
proto.ccgames.boardgame.Rts.Action.CompleteGame.prototype.getFinalSave = function() {
  return /** @type{?proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave, 1));
};


/**
 * @param {?proto.ccgames.boardgame.Rts.Action.SetGameState.FinalSave|undefined} value
 * @return {!proto.ccgames.boardgame.Rts.Action.CompleteGame} returns this
*/
proto.ccgames.boardgame.Rts.Action.CompleteGame.prototype.setFinalSave = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Rts.Action.CompleteGame} returns this
 */
proto.ccgames.boardgame.Rts.Action.CompleteGame.prototype.clearFinalSave = function() {
  return this.setFinalSave(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.Action.CompleteGame.prototype.hasFinalSave = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.Action.SetAnonymousPlayer.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.Action.SetAnonymousPlayer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.Action.SetAnonymousPlayer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.Action.SetAnonymousPlayer.toObject = function(includeInstance, msg) {
  var f, obj = {
    playerColor: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.Action.SetAnonymousPlayer}
 */
proto.ccgames.boardgame.Rts.Action.SetAnonymousPlayer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.Action.SetAnonymousPlayer;
  return proto.ccgames.boardgame.Rts.Action.SetAnonymousPlayer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.Action.SetAnonymousPlayer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.Action.SetAnonymousPlayer}
 */
proto.ccgames.boardgame.Rts.Action.SetAnonymousPlayer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ccgames.boardgame.Game.PlayerColor} */ (reader.readEnum());
      msg.setPlayerColor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.Action.SetAnonymousPlayer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.Action.SetAnonymousPlayer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.Action.SetAnonymousPlayer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.Action.SetAnonymousPlayer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlayerColor();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional Game.PlayerColor player_color = 1;
 * @return {!proto.ccgames.boardgame.Game.PlayerColor}
 */
proto.ccgames.boardgame.Rts.Action.SetAnonymousPlayer.prototype.getPlayerColor = function() {
  return /** @type {!proto.ccgames.boardgame.Game.PlayerColor} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ccgames.boardgame.Game.PlayerColor} value
 * @return {!proto.ccgames.boardgame.Rts.Action.SetAnonymousPlayer} returns this
 */
proto.ccgames.boardgame.Rts.Action.SetAnonymousPlayer.prototype.setPlayerColor = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.Action.ShowSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.Action.ShowSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
    kind: jspb.Message.getFieldWithDefault(msg, 1, 0),
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.Action.ShowSummary}
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.Action.ShowSummary;
  return proto.ccgames.boardgame.Rts.Action.ShowSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.Action.ShowSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.Action.ShowSummary}
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ccgames.boardgame.Rts.Action.ShowSummary.Kind} */ (reader.readEnum());
      msg.setKind(value);
      break;
    case 2:
      var value = new proto.ccgames.boardgame.Rts.Action.ShowSummary.Item;
      reader.readMessage(value,proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.Action.ShowSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.Action.ShowSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKind();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.Kind = {
  UNKNOWN: 0,
  QUICK: 1,
  ARENA_TOURNAMENT: 2,
  ONBOARDING_STEP: 3,
  ONBOARDING_COMPLETED: 4
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter.toObject = function(includeInstance, msg) {
  var f, obj = {
    currentValue: jspb.Message.getFieldWithDefault(msg, 1, 0),
    valueChange: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter}
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter;
  return proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter}
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCurrentValue(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setValueChange(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrentValue();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getValueChange();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional int64 current_value = 1;
 * @return {number}
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter.prototype.getCurrentValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter} returns this
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter.prototype.setCurrentValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 value_change = 2;
 * @return {number}
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter.prototype.getValueChange = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter} returns this
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.Counter.prototype.setValueChange = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.oneofGroups_ = [[1,2,3,4]];

/**
 * @enum {number}
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.ItemOneofCase = {
  ITEM_ONEOF_NOT_SET: 0,
  ELO_PROGRESS: 1,
  TOURNAMENT_PROGRESS: 2,
  ONBOARDING_PROGRESS: 3,
  ONBOARDING_RESULT: 4
};

/**
 * @return {proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.ItemOneofCase}
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.prototype.getItemOneofCase = function() {
  return /** @type {proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.ItemOneofCase} */(jspb.Message.computeOneofCase(this, proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.Action.ShowSummary.Item} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.toObject = function(includeInstance, msg) {
  var f, obj = {
    eloProgress: (f = msg.getEloProgress()) && proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.EloProgress.toObject(includeInstance, f),
    tournamentProgress: (f = msg.getTournamentProgress()) && proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress.toObject(includeInstance, f),
    onboardingProgress: (f = msg.getOnboardingProgress()) && proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingProgress.toObject(includeInstance, f),
    onboardingResult: (f = msg.getOnboardingResult()) && proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingResult.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.Action.ShowSummary.Item}
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.Action.ShowSummary.Item;
  return proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.Action.ShowSummary.Item} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.Action.ShowSummary.Item}
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.EloProgress;
      reader.readMessage(value,proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.EloProgress.deserializeBinaryFromReader);
      msg.setEloProgress(value);
      break;
    case 2:
      var value = new proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress;
      reader.readMessage(value,proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress.deserializeBinaryFromReader);
      msg.setTournamentProgress(value);
      break;
    case 3:
      var value = new proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingProgress;
      reader.readMessage(value,proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingProgress.deserializeBinaryFromReader);
      msg.setOnboardingProgress(value);
      break;
    case 4:
      var value = new proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingResult;
      reader.readMessage(value,proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingResult.deserializeBinaryFromReader);
      msg.setOnboardingResult(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.Action.ShowSummary.Item} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEloProgress();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.EloProgress.serializeBinaryToWriter
    );
  }
  f = message.getTournamentProgress();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress.serializeBinaryToWriter
    );
  }
  f = message.getOnboardingProgress();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingProgress.serializeBinaryToWriter
    );
  }
  f = message.getOnboardingResult();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingResult.serializeBinaryToWriter
    );
  }
};


/**
 * optional EloRankingExtension.ShowSummaryItem.EloProgress elo_progress = 1;
 * @return {?proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.EloProgress}
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.prototype.getEloProgress = function() {
  return /** @type{?proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.EloProgress} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.EloProgress, 1));
};


/**
 * @param {?proto.ccgames.boardgame.Rts.EloRankingExtension.ShowSummaryItem.EloProgress|undefined} value
 * @return {!proto.ccgames.boardgame.Rts.Action.ShowSummary.Item} returns this
*/
proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.prototype.setEloProgress = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Rts.Action.ShowSummary.Item} returns this
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.prototype.clearEloProgress = function() {
  return this.setEloProgress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.prototype.hasEloProgress = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional TournamentExtension.ShowSummaryItem.TournamentProgress tournament_progress = 2;
 * @return {?proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress}
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.prototype.getTournamentProgress = function() {
  return /** @type{?proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress, 2));
};


/**
 * @param {?proto.ccgames.boardgame.Rts.TournamentExtension.ShowSummaryItem.TournamentProgress|undefined} value
 * @return {!proto.ccgames.boardgame.Rts.Action.ShowSummary.Item} returns this
*/
proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.prototype.setTournamentProgress = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Rts.Action.ShowSummary.Item} returns this
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.prototype.clearTournamentProgress = function() {
  return this.setTournamentProgress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.prototype.hasTournamentProgress = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional OnboardingExtension.ShowSummaryItem.OnboardingProgress onboarding_progress = 3;
 * @return {?proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingProgress}
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.prototype.getOnboardingProgress = function() {
  return /** @type{?proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingProgress} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingProgress, 3));
};


/**
 * @param {?proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingProgress|undefined} value
 * @return {!proto.ccgames.boardgame.Rts.Action.ShowSummary.Item} returns this
*/
proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.prototype.setOnboardingProgress = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Rts.Action.ShowSummary.Item} returns this
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.prototype.clearOnboardingProgress = function() {
  return this.setOnboardingProgress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.prototype.hasOnboardingProgress = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional OnboardingExtension.ShowSummaryItem.OnboardingResult onboarding_result = 4;
 * @return {?proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingResult}
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.prototype.getOnboardingResult = function() {
  return /** @type{?proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingResult} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingResult, 4));
};


/**
 * @param {?proto.ccgames.boardgame.Rts.OnboardingExtension.ShowSummaryItem.OnboardingResult|undefined} value
 * @return {!proto.ccgames.boardgame.Rts.Action.ShowSummary.Item} returns this
*/
proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.prototype.setOnboardingResult = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Rts.Action.ShowSummary.Item} returns this
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.prototype.clearOnboardingResult = function() {
  return this.setOnboardingResult(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.Item.prototype.hasOnboardingResult = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Kind kind = 1;
 * @return {!proto.ccgames.boardgame.Rts.Action.ShowSummary.Kind}
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.prototype.getKind = function() {
  return /** @type {!proto.ccgames.boardgame.Rts.Action.ShowSummary.Kind} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ccgames.boardgame.Rts.Action.ShowSummary.Kind} value
 * @return {!proto.ccgames.boardgame.Rts.Action.ShowSummary} returns this
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.prototype.setKind = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * repeated Item items = 2;
 * @return {!Array<!proto.ccgames.boardgame.Rts.Action.ShowSummary.Item>}
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.ccgames.boardgame.Rts.Action.ShowSummary.Item>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ccgames.boardgame.Rts.Action.ShowSummary.Item, 2));
};


/**
 * @param {!Array<!proto.ccgames.boardgame.Rts.Action.ShowSummary.Item>} value
 * @return {!proto.ccgames.boardgame.Rts.Action.ShowSummary} returns this
*/
proto.ccgames.boardgame.Rts.Action.ShowSummary.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.ccgames.boardgame.Rts.Action.ShowSummary.Item=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ccgames.boardgame.Rts.Action.ShowSummary.Item}
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.ccgames.boardgame.Rts.Action.ShowSummary.Item, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ccgames.boardgame.Rts.Action.ShowSummary} returns this
 */
proto.ccgames.boardgame.Rts.Action.ShowSummary.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * optional Arbiter.Action.Move move = 1;
 * @return {?proto.ccgames.boardgame.Arbiter.Action.Move}
 */
proto.ccgames.boardgame.Rts.Action.prototype.getMove = function() {
  return /** @type{?proto.ccgames.boardgame.Arbiter.Action.Move} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Arbiter.Action.Move, 1));
};


/**
 * @param {?proto.ccgames.boardgame.Arbiter.Action.Move|undefined} value
 * @return {!proto.ccgames.boardgame.Rts.Action} returns this
*/
proto.ccgames.boardgame.Rts.Action.prototype.setMove = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.ccgames.boardgame.Rts.Action.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Rts.Action} returns this
 */
proto.ccgames.boardgame.Rts.Action.prototype.clearMove = function() {
  return this.setMove(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.Action.prototype.hasMove = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Arbiter.Action.SetAvailableMoves set_available_moves = 2;
 * @return {?proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves}
 */
proto.ccgames.boardgame.Rts.Action.prototype.getSetAvailableMoves = function() {
  return /** @type{?proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves, 2));
};


/**
 * @param {?proto.ccgames.boardgame.Arbiter.Action.SetAvailableMoves|undefined} value
 * @return {!proto.ccgames.boardgame.Rts.Action} returns this
*/
proto.ccgames.boardgame.Rts.Action.prototype.setSetAvailableMoves = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.ccgames.boardgame.Rts.Action.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Rts.Action} returns this
 */
proto.ccgames.boardgame.Rts.Action.prototype.clearSetAvailableMoves = function() {
  return this.setSetAvailableMoves(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.Action.prototype.hasSetAvailableMoves = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Arbiter.Action.SetSideToMove set_side_to_move = 3;
 * @return {?proto.ccgames.boardgame.Arbiter.Action.SetSideToMove}
 */
proto.ccgames.boardgame.Rts.Action.prototype.getSetSideToMove = function() {
  return /** @type{?proto.ccgames.boardgame.Arbiter.Action.SetSideToMove} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Arbiter.Action.SetSideToMove, 3));
};


/**
 * @param {?proto.ccgames.boardgame.Arbiter.Action.SetSideToMove|undefined} value
 * @return {!proto.ccgames.boardgame.Rts.Action} returns this
*/
proto.ccgames.boardgame.Rts.Action.prototype.setSetSideToMove = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.ccgames.boardgame.Rts.Action.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Rts.Action} returns this
 */
proto.ccgames.boardgame.Rts.Action.prototype.clearSetSideToMove = function() {
  return this.setSetSideToMove(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.Action.prototype.hasSetSideToMove = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Arbiter.Action.InitBoard init_board = 4;
 * @return {?proto.ccgames.boardgame.Arbiter.Action.InitBoard}
 */
proto.ccgames.boardgame.Rts.Action.prototype.getInitBoard = function() {
  return /** @type{?proto.ccgames.boardgame.Arbiter.Action.InitBoard} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Arbiter.Action.InitBoard, 4));
};


/**
 * @param {?proto.ccgames.boardgame.Arbiter.Action.InitBoard|undefined} value
 * @return {!proto.ccgames.boardgame.Rts.Action} returns this
*/
proto.ccgames.boardgame.Rts.Action.prototype.setInitBoard = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.ccgames.boardgame.Rts.Action.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Rts.Action} returns this
 */
proto.ccgames.boardgame.Rts.Action.prototype.clearInitBoard = function() {
  return this.setInitBoard(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.Action.prototype.hasInitBoard = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Arbiter.Action.Highlight highlight = 5;
 * @return {?proto.ccgames.boardgame.Arbiter.Action.Highlight}
 */
proto.ccgames.boardgame.Rts.Action.prototype.getHighlight = function() {
  return /** @type{?proto.ccgames.boardgame.Arbiter.Action.Highlight} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Arbiter.Action.Highlight, 5));
};


/**
 * @param {?proto.ccgames.boardgame.Arbiter.Action.Highlight|undefined} value
 * @return {!proto.ccgames.boardgame.Rts.Action} returns this
*/
proto.ccgames.boardgame.Rts.Action.prototype.setHighlight = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.ccgames.boardgame.Rts.Action.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Rts.Action} returns this
 */
proto.ccgames.boardgame.Rts.Action.prototype.clearHighlight = function() {
  return this.setHighlight(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.Action.prototype.hasHighlight = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Arbiter.Action.RevokeHighlight revoke_highlight = 6;
 * @return {?proto.ccgames.boardgame.Arbiter.Action.RevokeHighlight}
 */
proto.ccgames.boardgame.Rts.Action.prototype.getRevokeHighlight = function() {
  return /** @type{?proto.ccgames.boardgame.Arbiter.Action.RevokeHighlight} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Arbiter.Action.RevokeHighlight, 6));
};


/**
 * @param {?proto.ccgames.boardgame.Arbiter.Action.RevokeHighlight|undefined} value
 * @return {!proto.ccgames.boardgame.Rts.Action} returns this
*/
proto.ccgames.boardgame.Rts.Action.prototype.setRevokeHighlight = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.ccgames.boardgame.Rts.Action.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Rts.Action} returns this
 */
proto.ccgames.boardgame.Rts.Action.prototype.clearRevokeHighlight = function() {
  return this.setRevokeHighlight(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.Action.prototype.hasRevokeHighlight = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional DrawExtension.Action.SetDrawState set_draw_state = 10;
 * @return {?proto.ccgames.boardgame.Rts.DrawExtension.Action.SetDrawState}
 */
proto.ccgames.boardgame.Rts.Action.prototype.getSetDrawState = function() {
  return /** @type{?proto.ccgames.boardgame.Rts.DrawExtension.Action.SetDrawState} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Rts.DrawExtension.Action.SetDrawState, 10));
};


/**
 * @param {?proto.ccgames.boardgame.Rts.DrawExtension.Action.SetDrawState|undefined} value
 * @return {!proto.ccgames.boardgame.Rts.Action} returns this
*/
proto.ccgames.boardgame.Rts.Action.prototype.setSetDrawState = function(value) {
  return jspb.Message.setOneofWrapperField(this, 10, proto.ccgames.boardgame.Rts.Action.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Rts.Action} returns this
 */
proto.ccgames.boardgame.Rts.Action.prototype.clearSetDrawState = function() {
  return this.setSetDrawState(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.Action.prototype.hasSetDrawState = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional FirebaseExtension.Action.SetFirebasePlayer set_firebase_player = 11;
 * @return {?proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer}
 */
proto.ccgames.boardgame.Rts.Action.prototype.getSetFirebasePlayer = function() {
  return /** @type{?proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer, 11));
};


/**
 * @param {?proto.ccgames.boardgame.Rts.FirebaseExtension.Action.SetFirebasePlayer|undefined} value
 * @return {!proto.ccgames.boardgame.Rts.Action} returns this
*/
proto.ccgames.boardgame.Rts.Action.prototype.setSetFirebasePlayer = function(value) {
  return jspb.Message.setOneofWrapperField(this, 11, proto.ccgames.boardgame.Rts.Action.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Rts.Action} returns this
 */
proto.ccgames.boardgame.Rts.Action.prototype.clearSetFirebasePlayer = function() {
  return this.setSetFirebasePlayer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.Action.prototype.hasSetFirebasePlayer = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional ClockExtension.Action.SetPlayerClockState set_player_clock_state = 12;
 * @return {?proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState}
 */
proto.ccgames.boardgame.Rts.Action.prototype.getSetPlayerClockState = function() {
  return /** @type{?proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState, 12));
};


/**
 * @param {?proto.ccgames.boardgame.Rts.ClockExtension.Action.SetPlayerClockState|undefined} value
 * @return {!proto.ccgames.boardgame.Rts.Action} returns this
*/
proto.ccgames.boardgame.Rts.Action.prototype.setSetPlayerClockState = function(value) {
  return jspb.Message.setOneofWrapperField(this, 12, proto.ccgames.boardgame.Rts.Action.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Rts.Action} returns this
 */
proto.ccgames.boardgame.Rts.Action.prototype.clearSetPlayerClockState = function() {
  return this.setSetPlayerClockState(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.Action.prototype.hasSetPlayerClockState = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional SetGameState set_game_state = 13;
 * @return {?proto.ccgames.boardgame.Rts.Action.SetGameState}
 */
proto.ccgames.boardgame.Rts.Action.prototype.getSetGameState = function() {
  return /** @type{?proto.ccgames.boardgame.Rts.Action.SetGameState} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Rts.Action.SetGameState, 13));
};


/**
 * @param {?proto.ccgames.boardgame.Rts.Action.SetGameState|undefined} value
 * @return {!proto.ccgames.boardgame.Rts.Action} returns this
*/
proto.ccgames.boardgame.Rts.Action.prototype.setSetGameState = function(value) {
  return jspb.Message.setOneofWrapperField(this, 13, proto.ccgames.boardgame.Rts.Action.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Rts.Action} returns this
 */
proto.ccgames.boardgame.Rts.Action.prototype.clearSetGameState = function() {
  return this.setSetGameState(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.Action.prototype.hasSetGameState = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional ActivateGame activate_game = 14;
 * @return {?proto.ccgames.boardgame.Rts.Action.ActivateGame}
 */
proto.ccgames.boardgame.Rts.Action.prototype.getActivateGame = function() {
  return /** @type{?proto.ccgames.boardgame.Rts.Action.ActivateGame} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Rts.Action.ActivateGame, 14));
};


/**
 * @param {?proto.ccgames.boardgame.Rts.Action.ActivateGame|undefined} value
 * @return {!proto.ccgames.boardgame.Rts.Action} returns this
*/
proto.ccgames.boardgame.Rts.Action.prototype.setActivateGame = function(value) {
  return jspb.Message.setOneofWrapperField(this, 14, proto.ccgames.boardgame.Rts.Action.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Rts.Action} returns this
 */
proto.ccgames.boardgame.Rts.Action.prototype.clearActivateGame = function() {
  return this.setActivateGame(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.Action.prototype.hasActivateGame = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional CompleteGame complete_game = 15;
 * @return {?proto.ccgames.boardgame.Rts.Action.CompleteGame}
 */
proto.ccgames.boardgame.Rts.Action.prototype.getCompleteGame = function() {
  return /** @type{?proto.ccgames.boardgame.Rts.Action.CompleteGame} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Rts.Action.CompleteGame, 15));
};


/**
 * @param {?proto.ccgames.boardgame.Rts.Action.CompleteGame|undefined} value
 * @return {!proto.ccgames.boardgame.Rts.Action} returns this
*/
proto.ccgames.boardgame.Rts.Action.prototype.setCompleteGame = function(value) {
  return jspb.Message.setOneofWrapperField(this, 15, proto.ccgames.boardgame.Rts.Action.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Rts.Action} returns this
 */
proto.ccgames.boardgame.Rts.Action.prototype.clearCompleteGame = function() {
  return this.setCompleteGame(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.Action.prototype.hasCompleteGame = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional SetAnonymousPlayer set_anonymous_player = 16;
 * @return {?proto.ccgames.boardgame.Rts.Action.SetAnonymousPlayer}
 */
proto.ccgames.boardgame.Rts.Action.prototype.getSetAnonymousPlayer = function() {
  return /** @type{?proto.ccgames.boardgame.Rts.Action.SetAnonymousPlayer} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Rts.Action.SetAnonymousPlayer, 16));
};


/**
 * @param {?proto.ccgames.boardgame.Rts.Action.SetAnonymousPlayer|undefined} value
 * @return {!proto.ccgames.boardgame.Rts.Action} returns this
*/
proto.ccgames.boardgame.Rts.Action.prototype.setSetAnonymousPlayer = function(value) {
  return jspb.Message.setOneofWrapperField(this, 16, proto.ccgames.boardgame.Rts.Action.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Rts.Action} returns this
 */
proto.ccgames.boardgame.Rts.Action.prototype.clearSetAnonymousPlayer = function() {
  return this.setSetAnonymousPlayer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.Action.prototype.hasSetAnonymousPlayer = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional ShowSummary show_summary = 17;
 * @return {?proto.ccgames.boardgame.Rts.Action.ShowSummary}
 */
proto.ccgames.boardgame.Rts.Action.prototype.getShowSummary = function() {
  return /** @type{?proto.ccgames.boardgame.Rts.Action.ShowSummary} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Rts.Action.ShowSummary, 17));
};


/**
 * @param {?proto.ccgames.boardgame.Rts.Action.ShowSummary|undefined} value
 * @return {!proto.ccgames.boardgame.Rts.Action} returns this
*/
proto.ccgames.boardgame.Rts.Action.prototype.setShowSummary = function(value) {
  return jspb.Message.setOneofWrapperField(this, 17, proto.ccgames.boardgame.Rts.Action.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Rts.Action} returns this
 */
proto.ccgames.boardgame.Rts.Action.prototype.clearShowSummary = function() {
  return this.setShowSummary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.Action.prototype.hasShowSummary = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional TournamentExtension.Action.SetPlayerProgress set_tournament_player_progress = 18;
 * @return {?proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetPlayerProgress}
 */
proto.ccgames.boardgame.Rts.Action.prototype.getSetTournamentPlayerProgress = function() {
  return /** @type{?proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetPlayerProgress} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetPlayerProgress, 18));
};


/**
 * @param {?proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetPlayerProgress|undefined} value
 * @return {!proto.ccgames.boardgame.Rts.Action} returns this
*/
proto.ccgames.boardgame.Rts.Action.prototype.setSetTournamentPlayerProgress = function(value) {
  return jspb.Message.setOneofWrapperField(this, 18, proto.ccgames.boardgame.Rts.Action.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Rts.Action} returns this
 */
proto.ccgames.boardgame.Rts.Action.prototype.clearSetTournamentPlayerProgress = function() {
  return this.setSetTournamentPlayerProgress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.Action.prototype.hasSetTournamentPlayerProgress = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional TournamentExtension.Action.SetTournamentClock set_tournament_clock = 19;
 * @return {?proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetTournamentClock}
 */
proto.ccgames.boardgame.Rts.Action.prototype.getSetTournamentClock = function() {
  return /** @type{?proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetTournamentClock} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetTournamentClock, 19));
};


/**
 * @param {?proto.ccgames.boardgame.Rts.TournamentExtension.Action.SetTournamentClock|undefined} value
 * @return {!proto.ccgames.boardgame.Rts.Action} returns this
*/
proto.ccgames.boardgame.Rts.Action.prototype.setSetTournamentClock = function(value) {
  return jspb.Message.setOneofWrapperField(this, 19, proto.ccgames.boardgame.Rts.Action.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Rts.Action} returns this
 */
proto.ccgames.boardgame.Rts.Action.prototype.clearSetTournamentClock = function() {
  return this.setSetTournamentClock(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.Action.prototype.hasSetTournamentClock = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional EloRankingExtension.Action.SetPlayerElo set_player_elo = 20;
 * @return {?proto.ccgames.boardgame.Rts.EloRankingExtension.Action.SetPlayerElo}
 */
proto.ccgames.boardgame.Rts.Action.prototype.getSetPlayerElo = function() {
  return /** @type{?proto.ccgames.boardgame.Rts.EloRankingExtension.Action.SetPlayerElo} */ (
    jspb.Message.getWrapperField(this, proto.ccgames.boardgame.Rts.EloRankingExtension.Action.SetPlayerElo, 20));
};


/**
 * @param {?proto.ccgames.boardgame.Rts.EloRankingExtension.Action.SetPlayerElo|undefined} value
 * @return {!proto.ccgames.boardgame.Rts.Action} returns this
*/
proto.ccgames.boardgame.Rts.Action.prototype.setSetPlayerElo = function(value) {
  return jspb.Message.setOneofWrapperField(this, 20, proto.ccgames.boardgame.Rts.Action.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ccgames.boardgame.Rts.Action} returns this
 */
proto.ccgames.boardgame.Rts.Action.prototype.clearSetPlayerElo = function() {
  return this.setSetPlayerElo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ccgames.boardgame.Rts.Action.prototype.hasSetPlayerElo = function() {
  return jspb.Message.getField(this, 20) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ccgames.boardgame.Rts.Actions.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ccgames.boardgame.Rts.Actions.prototype.toObject = function(opt_includeInstance) {
  return proto.ccgames.boardgame.Rts.Actions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ccgames.boardgame.Rts.Actions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.Actions.toObject = function(includeInstance, msg) {
  var f, obj = {
    actionsList: jspb.Message.toObjectList(msg.getActionsList(),
    proto.ccgames.boardgame.Rts.Action.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ccgames.boardgame.Rts.Actions}
 */
proto.ccgames.boardgame.Rts.Actions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ccgames.boardgame.Rts.Actions;
  return proto.ccgames.boardgame.Rts.Actions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ccgames.boardgame.Rts.Actions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ccgames.boardgame.Rts.Actions}
 */
proto.ccgames.boardgame.Rts.Actions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ccgames.boardgame.Rts.Action;
      reader.readMessage(value,proto.ccgames.boardgame.Rts.Action.deserializeBinaryFromReader);
      msg.addActions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ccgames.boardgame.Rts.Actions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ccgames.boardgame.Rts.Actions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ccgames.boardgame.Rts.Actions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ccgames.boardgame.Rts.Actions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.ccgames.boardgame.Rts.Action.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Action actions = 1;
 * @return {!Array<!proto.ccgames.boardgame.Rts.Action>}
 */
proto.ccgames.boardgame.Rts.Actions.prototype.getActionsList = function() {
  return /** @type{!Array<!proto.ccgames.boardgame.Rts.Action>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ccgames.boardgame.Rts.Action, 1));
};


/**
 * @param {!Array<!proto.ccgames.boardgame.Rts.Action>} value
 * @return {!proto.ccgames.boardgame.Rts.Actions} returns this
*/
proto.ccgames.boardgame.Rts.Actions.prototype.setActionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.ccgames.boardgame.Rts.Action=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ccgames.boardgame.Rts.Action}
 */
proto.ccgames.boardgame.Rts.Actions.prototype.addActions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.ccgames.boardgame.Rts.Action, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ccgames.boardgame.Rts.Actions} returns this
 */
proto.ccgames.boardgame.Rts.Actions.prototype.clearActionsList = function() {
  return this.setActionsList([]);
};


goog.object.extend(exports, proto.ccgames.boardgame);
